import { computed as M, reactive as $e, watch as me, toRefs as wt, ref as ue, onBeforeUnmount as Xe, inject as Ne, createElementBlock as j, openBlock as C, renderSlot as P, createCommentVNode as K, unref as V, Fragment as re, renderList as ke, normalizeClass as ye, createElementVNode as ge, createVNode as Oe, Transition as Ge, withCtx as J, createBlock as Se, resolveDynamicComponent as Qe, mergeProps as de, toHandlers as Be, normalizeProps as ee, toDisplayString as ie, normalizeStyle as _e, onMounted as qe, withModifiers as xe, nextTick as Ue, createTextVNode as et, TransitionGroup as tt, createSlots as je, useTemplateRef as _t, useId as kt, useAttrs as bt, provide as $t, guardReactiveProps as ae } from "vue";
/**
  * vue-cal v5.0.1-rc.19
  * (c) 2024-2025 Antoni Andre <antoniandre.web@gmail.com>
  * @license MIT
  */
const fe = {
  texts: {
    weekDays: Array(7).fill(""),
    weekDaysShort: [],
    months: Array(12).fill(""),
    years: "",
    year: "",
    month: "",
    week: "",
    day: "",
    today: "",
    noEvent: "",
    allDay: "",
    deleteEvent: "",
    createEvent: "",
    dateFormat: "dddd MMMM D, YYYY",
    am: "am",
    pm: "pm",
    truncations: !0
  },
  availableViews: {
    day: { cols: 1, rows: 1 },
    days: { cols: 10, rows: 1 },
    week: { cols: 7, rows: 1 },
    month: { cols: 7, rows: 6 },
    year: { cols: 4, rows: 3 },
    years: { cols: 5, rows: 5 }
    // Arbitrary range of quarters of century (25y).
  }
}, Tt = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"], Re = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"], Mt = Re.reduce((y, s, r) => (y[s] = r || 7, y), {}), Yt = (y, s, r) => {
  const { dateUtils: d } = y, w = !1, b = M(() => {
    if (W.value[s.view]) return s.view;
    const l = s.datePicker ? "month" : "week", p = s.view || l;
    return W.value[p] ? p : (console.warn(
      `Vue Cal: the provided or default view \`${p}\` is either invalid or not in the list of available views. The first available view will be chosen: \`${Object.keys(W.value)[0]}\`.`
    ), Object.keys(W.value)[0]);
  }), H = M(() => s.sm && !s.xs), f = M(() => s.xs || s.datePicker), F = M(() => s.clickToNavigate || s.datePicker && s.clickToNavigate !== !1), u = M(() => {
    const l = {
      cell: {},
      // All possible event listeners to attach to cells.
      event: {}
      // All possible event listeners to attach to calendar events.
    }, p = (k) => k.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
    for (const [k, a] of Object.entries(r)) {
      const [O, B, R] = k.match(/^on(Cell|Event)(.+)$/) || [];
      O && (l[B.toLowerCase()][p(R).replace(/^-+|-+$/g, "")] = a);
    }
    return l;
  }), m = M(() => {
    var p;
    const l = {};
    return s.hideWeekends && (l[6] = !0) && (l[7] = !0), (p = s.hideWeekdays) != null && p.length && s.hideWeekdays.forEach((k) => l[Mt[k]] = !0), l;
  }), Y = M(() => s.hideWeekends || m.value[6] && m.value[7]), W = M(() => {
    const l = s.datePicker;
    let p = 0, k = {};
    const a = s.views;
    return l && !a ? {
      month: { ...fe.availableViews.month },
      year: { ...fe.availableViews.year },
      years: { ...fe.availableViews.years }
    } : (a ? (Array.isArray(a) ? k = a.reduce((O, B) => (typeof B == "string" && fe.availableViews[B] ? O[B] = fe.availableViews[B] : p++, O), {}) : typeof a == "object" && (k = Object.entries(a).reduce((O, [B, R]) => {
      const { cols: oe, rows: te } = fe.availableViews[B];
      return O[B] = { cols: R.cols || oe, rows: R.rows || te }, O;
    }, {})), p && console.warn("Vue Cal: the provided `views` prop contains invalid views that will be ignored."), Object.keys(k).length || (console.warn("Vue Cal: No valid view in the provided `views` prop. Falling back to default views."), k = { ...fe.availableViews })) : k = { ...fe.availableViews }, k);
  }), q = M(() => s.datePicker ? "month" : W.value.week ? "week" : Object.keys(W.value)[0]), t = M(() => {
    if (typeof s.selectedDate == "string") return d.stringToDate(s.selectedDate);
    if (s.selectedDate instanceof Date) return s.selectedDate;
    s.selectedDate ? console.warn("Vue Cal: The provided selected date is invalid:", s.selectedDate) : console.log("Vue Cal: Info - The provided selected date is undefined.");
  }), o = M(() => {
    if (!s.disableDays) return [];
    const l = [];
    if (Array.isArray(s.disableDays))
      for (let p of s.disableDays) {
        let k = p;
        typeof p == "string" ? k = d.stringToDate(p) : p instanceof Date && (p = d.formatDate(p, "YYYY-MM-DD")), k instanceof Date && !isNaN(k.getTime()) ? l.push(p) : console.warn("Vue Cal: The provided `disableDays` prop contains an invalid date:", p);
      }
    else console.warn("Vue Cal: The provided `disableDays` prop is invalid:", s.disableDays);
    return l;
  }), e = M(() => {
    let l = null;
    return s.minDate && typeof s.minDate == "string" ? l = d.stringToDate(s.minDate) : s.minDate && s.minDate instanceof Date && (l = s.minDate), (l == null ? void 0 : l.getTime()) || null;
  }), h = M(() => {
    let l = null;
    return s.maxDate && typeof s.maxDate == "string" ? l = d.stringToDate(s.maxDate) : s.maxDate && s.maxDate instanceof Date && (l = s.maxDate), (l == null ? void 0 : l.getTime()) || null;
  }), c = M(() => {
    var k;
    const { view: l } = y;
    return s.schedules.length && (l.isDay || l.isDays || l.isWeek) && ((k = s.schedules) == null ? void 0 : k.map((a, O) => ({ ...a, id: a.id ?? O + 1 }))) || void 0;
  }), E = M(() => {
    const l = {
      drag: !0,
      resize: !0,
      delete: !0,
      create: !0
    };
    return s.editableEvents === !0 ? l : s.editableEvents === !1 ? Object.keys(l).map((p) => l[p] = !1) : { ...l, ...s.editableEvents };
  }), L = M(() => {
    const { view: l } = y, { eventCount: p } = s;
    return (Array.isArray(p) ? p.includes(l.id) : p) && (l.isMonth && !s.eventsOnMonthView || l.isYear);
  }), z = async (l) => {
    var k;
    let p = /* @__PURE__ */ Object.assign({ "../i18n/ar.json": () => import("./i18n/ar.js").then((a) => a.default), "../i18n/bg.json": () => import("./i18n/bg.js").then((a) => a.default), "../i18n/bn.json": () => import("./i18n/bn.js").then((a) => a.default), "../i18n/bs.json": () => import("./i18n/bs.js").then((a) => a.default), "../i18n/ca.json": () => import("./i18n/ca.js").then((a) => a.default), "../i18n/cs.json": () => import("./i18n/cs.js").then((a) => a.default), "../i18n/da.json": () => import("./i18n/da.js").then((a) => a.default), "../i18n/de.json": () => import("./i18n/de.js").then((a) => a.default), "../i18n/el.json": () => import("./i18n/el.js").then((a) => a.default), "../i18n/en-gb.json": () => import("./i18n/en-gb.js").then((a) => a.default), "../i18n/en-us.json": () => Promise.resolve().then(() => Vt).then((a) => a.default), "../i18n/es.json": () => import("./i18n/es.js").then((a) => a.default), "../i18n/et.json": () => import("./i18n/et.js").then((a) => a.default), "../i18n/fa.json": () => import("./i18n/fa.js").then((a) => a.default), "../i18n/fi.json": () => import("./i18n/fi.js").then((a) => a.default), "../i18n/fr.json": () => import("./i18n/fr.js").then((a) => a.default), "../i18n/he.json": () => import("./i18n/he.js").then((a) => a.default), "../i18n/hr.json": () => import("./i18n/hr.js").then((a) => a.default), "../i18n/hu.json": () => import("./i18n/hu.js").then((a) => a.default), "../i18n/id.json": () => import("./i18n/id.js").then((a) => a.default), "../i18n/is.json": () => import("./i18n/is.js").then((a) => a.default), "../i18n/it.json": () => import("./i18n/it.js").then((a) => a.default), "../i18n/ja.json": () => import("./i18n/ja.js").then((a) => a.default), "../i18n/ka.json": () => import("./i18n/ka.js").then((a) => a.default), "../i18n/ko.json": () => import("./i18n/ko.js").then((a) => a.default), "../i18n/lt.json": () => import("./i18n/lt.js").then((a) => a.default), "../i18n/mn.json": () => import("./i18n/mn.js").then((a) => a.default), "../i18n/nl.json": () => import("./i18n/nl.js").then((a) => a.default), "../i18n/no.json": () => import("./i18n/no.js").then((a) => a.default), "../i18n/pl.json": () => import("./i18n/pl.js").then((a) => a.default), "../i18n/pt-br.json": () => import("./i18n/pt-br.js").then((a) => a.default), "../i18n/pt-pt.json": () => import("./i18n/pt-pt.js").then((a) => a.default), "../i18n/ro.json": () => import("./i18n/ro.js").then((a) => a.default), "../i18n/ru.json": () => import("./i18n/ru.js").then((a) => a.default), "../i18n/sk.json": () => import("./i18n/sk.js").then((a) => a.default), "../i18n/sl.json": () => import("./i18n/sl.js").then((a) => a.default), "../i18n/sq.json": () => import("./i18n/sq.js").then((a) => a.default), "../i18n/sr.json": () => import("./i18n/sr.js").then((a) => a.default), "../i18n/sv.json": () => import("./i18n/sv.js").then((a) => a.default), "../i18n/tr.json": () => import("./i18n/tr.js").then((a) => a.default), "../i18n/uk.json": () => import("./i18n/uk.js").then((a) => a.default), "../i18n/vi.json": () => import("./i18n/vi.js").then((a) => a.default), "../i18n/zh-cn.json": () => import("./i18n/zh-cn.js").then((a) => a.default), "../i18n/zh-hk.json": () => import("./i18n/zh-hk.js").then((a) => a.default) });
    {
      if (!p[`../i18n/${l}.json`]) {
        console.warn(`Vue Cal: the locale \`${l}\` does not exist. Falling back to \`en-us\`.`), l = "en-us";
        return;
      }
      p = await ((k = p[`../i18n/${l}.json`]) == null ? void 0 : k.call(p));
    }
    y.texts = Object.assign(y.texts, Object.assign({ ...fe.texts }, p)), d.updateTexts(y.texts);
  }, D = $e(s.events || []);
  return me(() => s.events, (l) => D.splice(0, D.length, ...l)), me(() => s.locale, (l) => z(l || "en-us")), (s.locale || !y.texts.today) && z(s.locale || "en-us"), {
    ...wt(s),
    events: D,
    // All the events listeners for cells and events that the end user may have attached to vue-cal.
    eventListeners: u,
    defaultView: q,
    availableViews: W,
    disableDays: o,
    ready: w,
    sm: H,
    xs: f,
    clickToNavigate: F,
    hideWeekdays: m,
    hideWeekends: Y,
    minTimestamp: e,
    maxTimestamp: h,
    schedules: c,
    selectedDate: t,
    editableEvents: E,
    showCellEventCount: L,
    view: b,
    // Getters.
    get hasHiddenDays() {
      return Object.keys(m.value).length;
    },
    get size() {
      return f.value ? "xs" : H.value ? "sm" : "lg";
    },
    loadTexts: z
  };
}, Ve = (y, s) => {
  const r = s.timeTo - s.timeFrom;
  return (y - s.timeFrom) * 100 / r;
}, Fe = (y, s) => {
  const r = s.timeTo - s.timeFrom;
  return ~~(y * r / 100 + s.timeFrom);
}, Ze = (y, s) => {
  const r = s.clientHeight;
  return y * 100 / r;
}, Ie = $e({ id: null, date: null });
let at = !1, Je = !0;
const pe = $e({ el: null, cell: null, timeout: null }), we = $e({
  eventId: null,
  fromVueCal: null,
  toVueCal: null
});
function Et(y) {
  const { config: s, view: r, eventsManager: d, emit: w, uid: b, dateUtils: H } = y, f = (e) => {
    var l;
    const { timeStep: h, timeCellHeight: c, timeFrom: E } = s, L = (((l = e.touches) == null ? void 0 : l[0]) || e).clientY, { top: z } = e.currentTarget.getBoundingClientRect(), D = L - z - ~~e.dataTransfer.getData("cursor-grab-at");
    return Fe(Ze(D, e.currentTarget), s);
  }, F = (e, h, c) => {
    const E = h.duration || u(h.start, h.end) || s.timeStep;
    let L = Math.max(f(e), 0);
    if (s.snapToInterval) {
      const p = L + s.snapToInterval / 2;
      L = p - p % s.snapToInterval;
    }
    const z = new Date(new Date(c).setMinutes(L)), D = Math.min(L + E, 24 * 60), l = new Date(new Date(c).setMinutes(D));
    return { start: z, end: l };
  }, u = (e, h) => Math.round((h - e) / 6e4);
  return {
    eventDragStart: (e, h) => {
      if (e.target.nodeType === 3 || y.touch.isResizingEvent) return e.preventDefault();
      e.dataTransfer.effectAllowed = "move", e.dataTransfer.dropEffect = "move";
      const c = { ...h, _: { id: h._.id, duration: u(h.start, h.end) } };
      try {
        e.dataTransfer.setData("text/plain", ""), e.dataTransfer.setData("event", JSON.stringify(c)), e.dataTransfer.setData("cursor-grab-at", e.offsetY);
      } catch (L) {
        return console.warn("Vue Cal: Failed to set drag data:", L), e.preventDefault();
      }
      we.eventId = h._.id, we.fromVueCal = b, w("event-drag-start", {
        e,
        event: h
      });
      const E = e.target.closest(".vuecal__event");
      E.classList.add("vuecal__event--dragging-ghost"), setTimeout(() => {
        E.classList.add("vuecal__event--dragging-original"), E.classList.remove("vuecal__event--dragging-ghost");
      }, 0), at = !1, Object.assign(Ie, { id: r.id, date: r.firstCellDate }), Je = !0, y.touch.isDraggingEvent = !0;
    },
    eventDragEnd: (e, h) => {
      we.eventId = null, e.target.closest(".vuecal__event").classList.remove("vuecal__event--dragging-original");
      const { fromVueCal: c, toVueCal: E } = we;
      E && c !== E && d.deleteEvent(h._.id, 3), at && Je && Ie.id && r.switchView(Ie.id, Ie.date, !0), w("event-drag-end", {
        e,
        event: h,
        external: we.fromVueCal !== b
      }), we.fromVueCal = null, we.toVueCal = null, y.touch.isDraggingEvent = !1;
    },
    cellDragEnter: (e, h) => {
      const { start: c } = h, E = e.currentTarget;
      if (!e.currentTarget.contains(e.relatedTarget)) {
        if (E === pe.el || !E.className.includes("vuecal__cell-content")) return !1;
        pe.el && (pe.cell.highlighted = !1), Object.assign(pe, { el: E, cell: h, timeout: clearTimeout(pe.timeout) }), h.highlighted = !0, ["years", "year", "month"].includes(r.id) && (pe.timeout = setTimeout(() => y.switchToNarrowerView(c), 2e3));
      }
    },
    cellDragOver: (e, h) => {
      const { start: c, schedule: E } = h;
      e.preventDefault(), h.highlighted = !0, (E || E === 0) && (h.highlightedSchedule = E);
    },
    cellDragLeave: (e, h) => {
      e.preventDefault(), !e.currentTarget.contains(e.relatedTarget) && (h.highlightedSchedule = !1, pe.cell === h && (clearTimeout(pe.timeout), Object.assign(pe, { el: null, cell: null, timeout: null }), h.highlighted = !1));
    },
    cellDragDrop: async (e, h) => {
      var a, O, B;
      e.preventDefault(), clearTimeout(pe.timeout), Object.assign(pe, { el: null, cell: null, timeout: null });
      const c = JSON.parse(e.dataTransfer.getData("event") || "{}");
      c.start && (c.start = new Date(c.start)), c.end && (c.end = new Date(c.end));
      let E;
      const { start: L, end: z } = F(e, c, h.start), { schedule: D } = ((a = e.target.closest("[data-schedule]")) == null ? void 0 : a.dataset) || {};
      let l = () => {
      };
      we.fromVueCal === b ? (E = d.getEvent(c._.id), E && (E._.dragging = !1, l = () => {
        E.start = L, E.end = z, D !== void 0 && (E.schedule = ~~D);
      })) : (E = {
        ...c,
        start: L,
        end: z,
        ...D !== void 0 && { schedule: ~~D },
        _: { id: ((O = c._) == null ? void 0 : O.id) || c.id, duration: u(L, z) },
        getOverlappingEvents: () => d.getEventsInRange(L, z, { schedule: ~~D })
      }, l = () => {
        E = d.createEvent(E);
      });
      let p = !0;
      const { drop: k } = (B = s.eventListeners) == null ? void 0 : B.event;
      k && (p = await k({
        e,
        event: { ...E, start: L, end: z, schedule: ~~D },
        overlaps: E.getOverlappingEvents({ start: L, end: z, schedule: ~~D }),
        cell: h,
        external: we.fromVueCal !== b
      })), p !== !1 && l(), h.highlighted = !1, h.highlightedSchedule = null, Je = !1, we.toVueCal = b, w("event-dropped", {
        e,
        cell: h,
        event: E,
        originalEvent: c,
        external: we.fromVueCal !== b
      });
    }
  };
}
const st = (y, s) => {
  let r, d, w, b = {}, H = {};
  const f = ue(y), F = () => {
    f.value.today || (f.value = s), Date.prototype.addDays = function(n) {
      return W(this, n || 0);
    }, Date.prototype.subtractDays = function(n) {
      return q(this, n || 0);
    }, Date.prototype.addHours = function(n) {
      return t(this, n || 0);
    }, Date.prototype.subtractHours = function(n) {
      return o(this, n || 0);
    }, Date.prototype.addMinutes = function(n) {
      return e(this, n || 0);
    }, Date.prototype.subtractMinutes = function(n) {
      return h(this, n || 0);
    }, Date.prototype.getWeek = function() {
      return E(this);
    }, Date.prototype.isToday = function() {
      return L(this);
    }, Date.prototype.isLeapYear = function() {
      return l(this);
    }, Date.prototype.format = function(n = "YYYY-MM-DD") {
      return oe(this, n);
    }, Date.prototype.formatTime = function(n = "HH:mm") {
      return se(this, n);
    };
  }, u = () => {
    delete Date.prototype.addDays, delete Date.prototype.subtractDays, delete Date.prototype.addHours, delete Date.prototype.subtractHours, delete Date.prototype.addMinutes, delete Date.prototype.subtractMinutes, delete Date.prototype.getWeek, delete Date.prototype.isToday, delete Date.prototype.isLeapYear, delete Date.prototype.format, delete Date.prototype.formatTime;
  }, m = (n) => {
    f.value = n, Date.prototype.subtractDays && F();
  }, Y = () => (d !== (/* @__PURE__ */ new Date()).getDate() && (r = /* @__PURE__ */ new Date(), d = r.getDate(), w = `${r.getFullYear()}-${r.getMonth()}-${r.getDate()}`), w), W = (n, _) => {
    const g = new Date(n.valueOf());
    return g.setDate(g.getDate() + _), g;
  }, q = (n, _) => {
    const g = new Date(n.valueOf());
    return g.setDate(g.getDate() - _), g;
  }, t = (n, _) => {
    const g = new Date(n.valueOf());
    return g.setHours(g.getHours() + _), g;
  }, o = (n, _) => {
    const g = new Date(n.valueOf());
    return g.setHours(g.getHours() - _), g;
  }, e = (n, _) => {
    const g = new Date(n.valueOf());
    return g.setMinutes(g.getMinutes() + _), g;
  }, h = (n, _) => {
    const g = new Date(n.valueOf());
    return g.setMinutes(g.getMinutes() - _), g;
  }, c = (n, _) => {
    const g = (A) => {
      const x = A % _;
      return x !== 0 && (A += x >= _ / 2 ? _ - x : -x), A;
    };
    if (typeof n == "number") return g(n);
    if (n instanceof Date) {
      let A = g(n.getMinutes());
      A >= 60 && (n.setHours(n.getHours() + 1), A = 0), n.setMinutes(A, 0, 0);
    }
  }, E = (n, _ = !1) => {
    const g = new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate())), A = g.getUTCDay() || 7;
    g.setUTCDate(g.getUTCDate() + 4 - A);
    const x = new Date(Date.UTC(g.getUTCFullYear(), 0, 1));
    return Math.ceil(((g - x) / 864e5 + 1) / 7) + (_ ? 1 : 0);
  }, L = (n) => `${n.getFullYear()}-${n.getMonth()}-${n.getDate()}` === Y(), z = (n, _) => {
    if (!n || !_) return console.warn(`Vue Cal: missing date${n ? "2" : "1"} parameter for comparison with \`isSameDate(date1, date2)\`.`);
    if (R(n)) {
      if (!R(_)) return console.warn(`Vue Cal: invalid date2 provided for comparison with \`isSameDate(date1, date2)\`: \`${_}\`.`);
    } else return console.warn(`Vue Cal: invalid date1 provided for comparison with \`isSameDate(date1, date2)\`: \`${n}\`.`);
    return n.getFullYear() === _.getFullYear() && n.getMonth() === _.getMonth() && n.getDate() === _.getDate();
  }, D = (n, _, g) => R(n) ? n.getTime() >= _ && n.getTime() <= g : console.warn(`Vue Cal: invalid date provided to \`isInRange(date, rangeStart, rangeEnd)\`: \`${n}\`.`), l = (n) => {
    const _ = n.getFullYear();
    return !(_ % 400) || _ % 100 && !(_ % 4);
  }, p = (n = null, _) => {
    const g = n && new Date(n.valueOf()) || /* @__PURE__ */ new Date(), A = _ ? 7 : 6;
    return g.setDate(g.getDate() - (g.getDay() + A) % 7), g;
  }, k = (n) => n instanceof Date ? n : (n.length === 10 && (n += " 00:00"), new Date(n.replace(/-/g, "/"))), a = (n) => n.getHours() * 60 + n.getMinutes(), O = (n, _) => {
    typeof n == "string" && (n = n.replace(/-/g, "/")), typeof _ == "string" && (_ = _.replace(/-/g, "/")), n = new Date(n).setHours(0, 0, 0, 0), _ = new Date(_).setHours(0, 0, 1, 0);
    const g = (new Date(_).getTimezoneOffset() - new Date(n).getTimezoneOffset()) * 60 * 1e3;
    return Math.ceil((_ - n - g) / (24 * 3600 * 1e3));
  }, B = (n, _, g) => Math.abs(n.getTime() - _.getTime()) <= g * 60 * 1e3, R = (n) => n && n instanceof Date && !isNaN(n), oe = (n, _ = "YYYY-MM-DD", g = null) => {
    if (g || (g = f.value), _ || (_ = "YYYY-MM-DD"), _ === "YYYY-MM-DD") return te(n);
    b = {}, H = {};
    const A = {
      YYYY: () => Q(n, g).YYYY,
      YY: () => Q(n, g).YY(),
      M: () => Q(n, g).M,
      MM: () => Q(n, g).MM(),
      MMM: () => Q(n, g).MMM(),
      MMMM: () => Q(n, g).MMMM(),
      MMMMG: () => Q(n, g).MMMMG(),
      D: () => Q(n, g).D,
      DD: () => Q(n, g).DD(),
      S: () => Q(n, g).S(),
      d: () => Q(n, g).d,
      dd: () => Q(n, g).dd(),
      ddd: () => Q(n, g).ddd(),
      dddd: () => Q(n, g).dddd(),
      HH: () => le(n, g).HH,
      H: () => le(n, g).H,
      hh: () => le(n, g).hh,
      h: () => le(n, g).h,
      am: () => le(n, g).am,
      AM: () => le(n, g).AM,
      mm: () => le(n, g).mm,
      m: () => le(n, g).m,
      s: () => le(n, g).s
    };
    return _.replace(/(\{[a-zA-Z]+\}|[a-zA-Z]+)/g, (x, he) => {
      const i = A[he.replace(/\{|\}/g, "")];
      return i !== void 0 ? i() : he;
    });
  }, te = (n) => {
    const _ = n.getMonth() + 1, g = n.getDate();
    return `${n.getFullYear()}-${_ < 10 ? "0" : ""}${_}-${g < 10 ? "0" : ""}${g}`;
  }, se = (n, _ = "HH:mm", g = null, A = !1) => {
    let x = !1;
    if (A) {
      const [T, S, $] = [n.getHours(), n.getMinutes(), n.getSeconds()];
      T + S + $ === 141 && (x = !0);
    }
    if (n instanceof Date && _ === "HH:mm") return x ? "24:00" : ce(n);
    H = {}, g || (g = f.value);
    const he = le(n, g), i = _.replace(/(\{[a-zA-Z]+\}|[a-zA-Z]+)/g, (T, S) => {
      const $ = he[S.replace(/\{|\}/g, "")];
      return $ !== void 0 ? $ : S;
    });
    return x ? i.replace("23:59", "24:00") : i;
  }, ce = (n) => {
    const _ = n.getHours(), g = n.getMinutes();
    return `${(_ < 10 ? "0" : "") + _}:${(g < 10 ? "0" : "") + g}`;
  }, X = (n) => {
    const _ = Math.floor(n / 60).toString().padStart(2, 0), g = (n % 60).toString().padStart(2, 0);
    return `${_}:${g}`;
  }, Ee = (n) => {
    if (n > 3 && n < 21) return "th";
    switch (n % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  }, Q = (n, _) => {
    if (b.D) return b;
    const g = n.getFullYear(), A = n.getMonth() + 1, x = n.getDate(), i = (n.getDay() - 1 + 7) % 7;
    return b = {
      // Year.
      YYYY: g,
      // 2024.
      YY: () => g.toString().substring(2),
      // 24.
      // Month.
      M: A,
      // 1 to 12.
      MM: () => A.toString().padStart(2, 0),
      // 01 to 12.
      MMM: () => _.months[A - 1].substring(0, 3),
      // Jan to Dec.
      MMMM: () => _.months[A - 1],
      // January to December.
      MMMMG: () => (_.monthsGenitive || _.months)[A - 1],
      // January to December in genitive form (Greek...)
      // Day.
      D: x,
      // 1 to 31.
      DD: () => x.toString().padStart(2, 0),
      // 01 to 31.
      S: () => Ee(x),
      // st, nd, rd, th.
      // Day of the week.
      d: i + 1,
      // 1 to 7 with 7 = Sunday.
      // Some locales have same start for all the days, so they have specific abbrev in weekDaysShort.
      dd: () => _.weekDaysShort.length ? _.weekDaysShort[i] : _.weekDays[i][0],
      // M to S.
      ddd: () => _.weekDaysShort.length ? _.weekDaysShort[i] : _.weekDays[i].substr(0, 3),
      // Mon to Sun.
      dddd: () => _.weekDays[i]
      // Monday to Sunday.
    }, b;
  }, le = (n, _) => {
    if (H.am) return H;
    let g, A, x;
    n instanceof Date ? (g = n.getHours(), A = n.getMinutes(), x = n.getSeconds()) : (g = Math.floor(n / 60), A = Math.floor(n % 60));
    const he = g % 12 ? g % 12 : 12, i = (_ || { am: "am", pm: "pm" })[g === 24 || g < 12 ? "am" : "pm"];
    return H = {
      H: g,
      h: he,
      HH: g.toString().padStart(2, 0),
      hh: he.toString().padStart(2, 0),
      am: i,
      AM: i.toUpperCase(),
      m: A,
      mm: A.toString().padStart(2, 0),
      s: x
    }, H;
  };
  return {
    addDatePrototypes: F,
    removeDatePrototypes: u,
    updateTexts: m,
    addDays: W,
    subtractDays: q,
    addHours: t,
    subtractHours: o,
    addMinutes: e,
    subtractMinutes: h,
    snapToInterval: c,
    getWeek: E,
    isToday: L,
    isSameDate: z,
    isInRange: D,
    isLeapYear: l,
    getPreviousFirstDayOfWeek: p,
    stringToDate: k,
    dateToMinutes: a,
    countDays: O,
    datesInSameTimeStep: B,
    isValid: R,
    formatDate: oe,
    formatDateLite: te,
    formatTime: se,
    formatTimeLite: ce,
    formatMinutes: X
  };
}, St = (y) => {
  const { dateUtils: s, config: r } = y;
  let d = 0;
  const w = M(() => {
    const t = {
      // A map of events indexed by { YYYY: { MM: { DD: [] } } }.
      // Each year contains a map of 12 months starting from 1, each containing a map of days starting from 1, each containing an array of event IDs.
      byYear: {},
      byDate: {},
      // A map of single-day events indexed by date.
      recurring: [],
      // An array of events IDs that are recurring.
      multiday: [],
      // An array of events IDs that are multiday.
      byId: {}
      // A map of all the events indexed by ID for fast lookup. Each event is the original full event object.
    }, o = r.events.sort((e, h) => e.start - h.start < 0 ? -1 : 1);
    for (const e of o)
      if (b(e), H(e), t.byId[e._.id] = e, e.recurring)
        t.recurring.push(e._.id);
      else if (e._.multiday)
        t.multiday.push(e._.id), t.byDate[e._.startFormatted] || (t.byDate[e._.startFormatted] = []), t.byDate[e._.startFormatted].push(e._.id);
      else {
        t.byDate[e._.startFormatted] || (t.byDate[e._.startFormatted] = []), t.byDate[e._.startFormatted].push(e._.id);
        const h = e._.startFormatted.substring(0, 4), c = e._.startFormatted.substring(5, 7), E = e._.startFormatted.substring(8, 10);
        t.byYear[h] || (t.byYear[h] = {}), t.byYear[h][c] || (t.byYear[h][c] = {}), t.byYear[h][c][E] || (t.byYear[h][c][E] = []), t.byYear[h][c][E].push(e._.id);
      }
    return t;
  }), b = (t) => {
    if (typeof t.start == "string" && (t.start = s.stringToDate(t.start)), typeof t.end == "string" && (t.end = s.stringToDate(t.end)), t.start.setSeconds(0, 0), t.end.setSeconds(0, 0), isNaN(t.start) || isNaN(t.end)) {
      isNaN(t.start) ? console.error(`Vue Cal: invalid start date for event "${t.title}".`, t.start) : console.error(`Vue Cal: invalid end date for event "${t.title}".`, t.end);
      return;
    } else t.end.getTime() < t.start.getTime() && console.error(`Vue Cal: invalid event dates for event "${t.title}". The event ends before it starts.`, t.start, t.end);
    t._ || (t._ = {}), t._.multiday = !s.isSameDate(t.start, new Date(t.end.getTime() - 1)), t._.startFormatted = s.formatDate(t.start), t._.startMinutes = ~~s.dateToMinutes(t.start), t._.endMinutes = ~~s.dateToMinutes(t.end);
    const o = t.start.getHours(), e = t.start.getMinutes().toString().padStart(2, 0), h = t.end.getHours(), c = t.end.getMinutes().toString().padStart(2, 0);
    t._.startTimeFormatted24 = `${o.toString().padStart(2, 0)}:${e}`, t._.startTimeFormatted12 = `${o % 12 || 12}${e ? `:${e}` : ""} ${o < 12 ? "AM" : "PM"}`, t._.endTimeFormatted24 = `${h.toString().padStart(2, 0)}:${c}`, t._.endTimeFormatted12 = `${h % 12 || 12}${c ? `:${c}` : ""} ${h < 12 ? "AM" : "PM"}`, t._.duration = Math.abs(~~((t.end - t.start) / 6e4));
  }, H = (t) => {
    t._ || (t._ = {}), t._.id = t._.id || ++d, t.delete || (t.delete = (o) => m(t._.id, o)), t._.deleting = !1, t._.deleted = !1, t.isOverlapping = (o = null) => t.getOverlappingEvents(o).length, t.getOverlappingEvents = (o = null) => {
      var e;
      return W(
        (o == null ? void 0 : o.start) || t.start,
        (o == null ? void 0 : o.end) || t.end,
        { excludeIds: [t._.id], schedule: (e = r.schedules) != null && e.length ? ~~((o == null ? void 0 : o.schedule) || t.schedule) : null }
      );
    }, t._.register = (o) => {
      t._.$el = o, t._.fireCreated && (y.emit("event-created", t), delete t._.fireCreated);
    }, t._.unregister = () => {
      t._.$el = null, t._.register = null, t.isOverlapping = null, t.getOverlappingEvents = null, t.delete = null;
    };
  }, f = (t) => w.value.byId[t], F = (t) => {
    const o = [];
    for (const { start: e, end: h } of t) {
      const c = W(e, h);
      c.length && o.push(...c);
    }
    return o;
  }, u = (t) => {
    if (!t.start || !t.end) {
      console.error("Vue Cal: Cannot create an event without valid start and end dates.");
      return;
    }
    return r.snapToInterval && (s.snapToInterval(t.start, r.snapToInterval), s.snapToInterval(t.end, r.snapToInterval)), t = { ...t }, t._ || (t._ = {}), t._.id = ++d, t._.fireCreated = !0, r.events.push(t), t;
  }, m = async (t, o = 0) => {
    var L, z;
    if (!t) return console.warn("Vue Cal: Cannot delete event without its ID or criteria.");
    let e = typeof t == "string" || !isNaN(t) ? t : null;
    const h = typeof t == "object" ? Object.entries(t) : null;
    if (h) {
      const [D, l] = h[0];
      e = (L = r.events.find((p) => p[D] === l)) == null ? void 0 : L._.id;
    }
    if (!r.editableEvents.delete)
      return console.info("Vue Cal: Event deletion is disabled. Enable it with the `editable-events` props.");
    if (!e) return console.warn("Vue Cal: Cannot delete event without its ID.");
    const c = r.events.findIndex((D) => D._.id === e);
    if (c === -1) return console.warn(`Vue Cal: Cannot delete unknown event \`${e}\`.`);
    const E = r.events[c];
    if (E.deletable === !1) return console.warn(`Vue Cal: Can't delete event \`${e}\` since it was explicitely set to \`delete: false\`.`);
    switch (o) {
      case 0:
        E._.deleting ? r.events.splice(c, 1) : E._.deleting = !0;
        break;
      // Display the delete button.
      case 1:
        E._.deleting = !0;
        break;
      // Visual deletion + external DOM event firing.
      // When explicitly using this stage, the event will be visually deleted but still present in the
      // source of truth until the cell is unmounted (by navigating away).
      case 2:
        E._.deleted = !0, r.events[c]._.deleted = !0, (z = E._.$el) == null || z.dispatchEvent(new CustomEvent("event-deleted", { detail: E._.id }));
        break;
      // Effective deletion from the source of truth (by default, when unmounting the cell).
      case 3:
        r.events.splice(c, 1), y.emit("update:events", r.events), y.emit("event-delete", E);
        break;
    }
    return !0;
  }, Y = (t, o) => {
    const e = W(t, o);
    if (!e.length) return { cellOverlaps: {}, longestStreak: 0 };
    const h = {};
    let c = [], E = 0;
    e.sort((L, z) => L.start - z.start || L.end - L.start - (z.end - z.start));
    for (const L of e) {
      const z = L._.id;
      h[z] || (h[z] = { overlaps: /* @__PURE__ */ new Set(), maxConcurrent: 1, position: 0 }), c = c.filter((a) => a.end > L.start);
      const D = c.filter((a) => {
        var B;
        return (!((B = r.schedules) != null && B.length) || L.schedule === a.schedule) && a.start < L.end;
      }), l = new Set(D.map((a) => {
        var O;
        return ((O = h[a._.id]) == null ? void 0 : O.position) ?? 0;
      }));
      let p = 0;
      for (; l.has(p); ) p++;
      h[z].position = p, c.push(L);
      const k = Math.max(1, ...D.map((a) => {
        var O;
        return ((O = h[a._.id]) == null ? void 0 : O.maxConcurrent) ?? 1;
      }));
      h[z].maxConcurrent = Math.max(D.length + 1, k);
      for (const a of D)
        h[a._.id].overlaps.add(z), h[z].overlaps.add(a._.id), h[a._.id].maxConcurrent = h[z].maxConcurrent;
      E = Math.max(E, h[z].maxConcurrent);
    }
    for (const L in h) h[L].overlaps = [...h[L].overlaps];
    return { cellOverlaps: h, longestStreak: E };
  }, W = (t, o, { excludeIds: e = [], schedule: h = null, background: c = !0 } = {}) => {
    const E = t.getFullYear(), L = o.getFullYear(), z = t.getMonth() + 1, D = o.getMonth() + 1, l = t.getDate(), p = o.getDate(), k = t.getTime(), a = o.getTime(), O = [], B = new Set(e);
    for (let R = E; R <= L; R++) {
      const oe = `${R}`, te = w.value.byYear[oe];
      if (!te) continue;
      const se = R === E ? z : 1, ce = R === L ? D : 12;
      for (let X = se; X <= ce; X++) {
        const Ee = String(X).padStart(2, "0"), Q = te[Ee];
        if (Q)
          for (const le in Q) {
            const n = +le;
            if (R === E && X === z && n < l || R === L && X === D && n > p) continue;
            const _ = Q[le];
            for (let g = 0; g < _.length; g++) {
              const A = w.value.byId[_[g]];
              !A || B.has(A._.id) || h !== null && h !== A.schedule || c === !1 && A.background || A.end.getTime() > k && A.start.getTime() < a && O.push(A);
            }
          }
      }
    }
    return O;
  };
  return {
    events: w,
    getEvent: f,
    getViewEvents: F,
    getCellOverlappingEvents: Y,
    getEventsInRange: W,
    createEvent: u,
    deleteEvent: m,
    isEventInRange: (t, o, e) => {
      const h = t.allDay || !r.time, c = h ? new Date(t.start).setHours(0, 0, 0, 0) : t.start.getTime(), E = h ? new Date(t.end).setHours(23, 59, 59, 999) : t.end.getTime(), L = h ? new Date(o).setHours(0, 0, 0, 0) : o.getTime(), z = h ? new Date(e).setHours(23, 59, 59, 999) : e.getTime();
      return E > L && c < z;
    }
  };
}, Ct = ({ config: y, dateUtils: s, emit: r, texts: d, eventsManager: w }, b) => {
  const { availableViews: H } = y, f = ue(y.view && H[y.view] ? y.view : y.defaultView), F = ue(y.selectedDate || null), u = ue(/* @__PURE__ */ new Date()), m = ue(new Date(y.viewDate || u.value));
  m.value.setHours(0, 0, 0, 0);
  const Y = ue(new Date(m));
  let W = null;
  const q = M(() => f.value === "month" ? Y.value : l.value), t = M(() => f.value === "month" ? new Date(Y.value.getFullYear(), Y.value.getMonth() + 1, 0, 23, 59, 59, 999) : k.value), o = M(() => f.value === "week" ? s.getPreviousFirstDayOfWeek(l.value, y.startWeekOnSunday) : f.value === "month" ? l.value : q.value), e = M(() => {
    if (f.value === "week") {
      const v = s.addDays(o.value, 7);
      return v.setMilliseconds(-1), v;
    }
    return f.value === "month" ? k.value : t.value;
  }), h = M(() => {
    const v = u.value.getTime();
    if (f.value === "week")
      return o.value.getTime() <= v && v <= e.value.getTime();
    const N = l.value.getTime(), Z = k.value.getTime();
    return N <= v && v <= Z;
  });
  function c() {
    u.value = /* @__PURE__ */ new Date(), W = setTimeout(c, 60 * 1e3);
  }
  function E() {
    W = setTimeout(c, (60 - (/* @__PURE__ */ new Date()).getSeconds()) * 1e3), c();
  }
  const L = M(() => {
    if (!y.availableViews[f.value]) return 1;
    let v = y.availableViews[f.value].cols;
    return y.hasHiddenDays && ["week", "month"].includes(f.value) && (v -= y.hasHiddenDays), v;
  }), z = M(() => {
    var v;
    return ((v = y.availableViews[f.value]) == null ? void 0 : v.rows) || 1;
  }), D = M(() => L.value * z.value), l = M(() => {
    if (f.value === "month") {
      let v = Y.value.getDay() || 7;
      return y.startWeekOnSunday && !y.hideWeekdays[7] && (v += 1), y.viewDayOffset && (v -= y.viewDayOffset), s.subtractDays(Y.value, v - 1);
    }
    if (f.value === "week") {
      const v = "1234567".split("").filter((Z) => !Object.keys(y.hideWeekdays).includes(Z));
      let N = Math.min(...v);
      return y.startWeekOnSunday && !y.hideWeekdays[7] && (N = 1), y.viewDayOffset && (N += y.viewDayOffset), s.addDays(Y.value, N - 1);
    }
    return Y.value;
  }), p = M(() => {
    const v = [], N = ["days", "week", "month"].includes(f.value);
    let Z = 0;
    for (let U = 0; U < D.value + Z; U++)
      switch (f.value) {
        case "day":
        case "days":
        case "week":
        case "month": {
          const ve = s.addDays(l.value, U), We = ve.getDay() || 7;
          if (N && y.hasHiddenDays && y.hideWeekdays[We]) {
            Z++;
            continue;
          }
          const Ce = new Date(ve);
          Ce.setHours(23, 59, 59, 999), v.push({ start: ve, startFormatted: s.formatDate(ve), end: Ce });
          break;
        }
        case "year":
          v.push({
            start: new Date(l.value.getFullYear(), U, 1, 0, 0, 0, 0),
            end: new Date(l.value.getFullYear(), U + 1, 0, 23, 59, 59, 999)
          });
          break;
        case "years":
          v.push({
            start: new Date(l.value.getFullYear() + U, 0, 1, 0, 0, 0, 0),
            end: new Date(l.value.getFullYear() + U + 1, 0, 0, 23, 59, 59, 999)
          });
          break;
      }
    return v;
  }), k = M(() => p.value[p.value.length - 1].end), a = ue("right"), O = M(() => {
    const v = Object.keys(y.availableViews);
    return v[v.indexOf(f.value) + 1];
  }), B = M(() => {
    const v = Object.keys(y.availableViews);
    return v[v.indexOf(f.value) - 1];
  });
  function R(v, N, Z = !1) {
    if (!N || !N[v]) return v + 1;
    const U = N[v];
    return Z && typeof U == "string" ? U.substring(0, 3) : U;
  }
  function oe(v, N, Z) {
    const { monthsArray: U, monthBeforeDay: ve, canTruncate: We, xs: Ce } = Z, Te = v.getMonth(), Me = v.getFullYear(), Ye = N.getMonth(), Pe = N.getFullYear(), Ae = Te !== Ye, pt = Me !== Pe, be = We && (Ce || Ae), Le = v.getDate(), He = N.getDate();
    return pt ? ve ? `${R(Te, U, be)} ${Le}, ${Me} - ${R(Ye, U, be)} ${He}, ${Pe}` : `${Le} ${R(Te, U, be)} ${Me} - ${He} ${R(Ye, U, be)} ${Pe}` : Ae ? ve ? `${R(Te, U, be)} ${Le} - ${R(Ye, U, be)} ${He}, ${Me}` : `${Le} ${R(Te, U, be)} - ${He} ${R(Ye, U, be)} ${Me}` : ve ? `${R(Te, U, be)} ${Le}-${He}, ${Me}` : `${Le}-${He} ${R(Te, U, be)} ${Me}`;
  }
  const te = M(() => {
    const { dateFormat: v, months: N, monthsGenitive: Z, week: U, truncations: ve } = d, We = y.locale, Ce = ve !== !1, Te = v.indexOf("M") < v.indexOf("D"), Me = Z && We === "el" ? Z : N;
    switch (f.value) {
      case "day":
        return s.formatDate(l.value, v);
      case "days":
      case "week": {
        const Ye = {
          monthsArray: Me,
          monthBeforeDay: Te,
          canTruncate: Ce,
          xs: y.xs
        };
        let Pe = oe(l.value, k.value, Ye);
        if (f.value === "week") {
          const Ae = s.getWeek(
            l.value,
            y.startWeekOnSunday && !y.hideWeekdays[7]
          );
          Pe += ` <small>${U} ${Ae}</small>`;
        }
        return Pe;
      }
      case "month": {
        const Ye = `${y.xs && Ce ? "MMM" : "MMMM"} YYYY`;
        return s.formatDate(q.value, Ye);
      }
      case "year":
        return l.value.getFullYear();
      case "years":
        return `${l.value.getFullYear()} - ${t.value.getFullYear()}`;
    }
  });
  function se() {
    switch (Y.value = new Date(m.value || u.value), Y.value.setHours(0, 0, 0, 0), f.value) {
      case "day":
        break;
      case "days":
        break;
      case "week":
        Y.value = s.getPreviousFirstDayOfWeek(Y.value, y.startWeekOnSunday && !y.hideWeekdays[7]);
        break;
      case "month":
        Y.value = new Date(Y.value.getFullYear(), Y.value.getMonth(), 1, 0, 0, 0, 0);
        break;
      case "year":
        Y.value = new Date(Y.value.getFullYear(), 0, 1, 0, 0, 0, 0);
        break;
      case "years":
        Y.value = new Date(Y.value.getFullYear() - Y.value.getFullYear() % D.value, 0, 1, 0, 0, 0, 0);
        break;
    }
    y.ready && r("view-change", {
      id: f.value,
      title: te.value,
      start: q.value,
      end: t.value,
      extendedStart: o.value,
      extendedEnd: e.value,
      cellDates: p.value,
      containsToday: h.value,
      events: G.value
    }), u.value = /* @__PURE__ */ new Date();
  }
  function ce(v) {
    const N = f.value, Z = y.availableViews[N];
    v[N] && JSON.stringify(v[N]) === JSON.stringify(Z) || se();
  }
  function X(v, N = !0) {
    const Z = Object.keys(y.availableViews);
    f.value !== v && (Z.includes(v) ? (a.value = Z.indexOf(v) < Z.indexOf(f.value) ? "left" : "right", f.value = v, r("update:view", v), se()) : console.warn(`Vue Cal: the \`${v}\` view is not available.`));
  }
  function Ee() {
    O.value ? X(O.value) : console.warn("Vue Cal: no broader view is available.");
  }
  function Q() {
    B.value ? X(B.value) : console.warn("Vue Cal: no narrower view is available.");
  }
  function le() {
    _(!1);
  }
  function n() {
    _(!0);
  }
  function _(v = !0) {
    let N = new Date(m.value);
    switch (f.value) {
      case "day":
      case "days":
        v ? N = s.addDays(k.value, 1) : N = s.subtractDays(l.value, D.value);
        break;
      case "week": {
        v ? (N = s.addDays(e.value, 1), N.setHours(0, 0, 0, 0)) : N = s.subtractDays(o.value, D.value);
        break;
      }
      case "month": {
        const Z = v ? 1 : -1;
        N = new Date(N.getFullYear(), N.getMonth() + Z, 1, 0, 0, 0, 0);
        break;
      }
      case "year": {
        const Z = v ? 1 : -1;
        N = new Date(N.getFullYear() + Z, 1, 1, 0, 0, 0, 0);
        break;
      }
      case "years": {
        const Z = v ? D.value : -D.value;
        N = new Date(N.getFullYear() + Z, 1, 1, 0, 0, 0, 0);
        break;
      }
    }
    A(N);
  }
  function g() {
    const v = /* @__PURE__ */ new Date();
    v.setHours(0, 0, 0, 0), A(v);
  }
  function A(v, N = !0, Z = !1) {
    if (!s.isValid(v)) return console.warn("Vue Cal: can't navigate to the given date: invalid date provided to `updateViewDate(date)`.");
    let [U, ve] = [l.value, k.value];
    f.value === "month" && ([U, ve] = [q.value, t.value]), (!s.isInRange(v, U, ve) || Z) && (v.setHours(0, 0, 0, 0), a.value = v.getTime() < U.getTime() ? "left" : "right", m.value = v, N && r("update:viewDate", v), se());
  }
  function x(v, N = !0) {
    if (!s.isValid(v)) return console.warn("Vue Cal: can't update the selected date: invalid date provided to `updateSelectedDate(date)`.");
    const { isValid: Z, isSameDate: U } = s;
    (!F.value || !Z(F.value) || !U(v, F.value)) && (v.setHours(0, 0, 0, 0), F.value = v, N && r("update:selectedDate", v));
  }
  function he(v) {
    !v && !Y.value.getDay() ? A(s.addDays(Y.value, 1), !0, !0) : (a.value = "left", se());
  }
  function i(v) {
    v && y.startWeekOnSunday && !Y.value.getDay() ? A(s.addDays(Y.value, 1), !0, !0) : !v && y.startWeekOnSunday && Y.value.getDay() === 1 && A(s.subtractDays(Y.value, 1), !0, !0);
  }
  function T() {
    console.log("toggling weekdays", y.hideWeekdays);
  }
  function S(v) {
    var U;
    const N = (U = b.value) == null ? void 0 : U.querySelector(".vuecal__scrollable"), Z = v ? v * y.timeCellHeight / y.timeStep : 0;
    N == null || N.scrollTo({ top: Z, behavior: "smooth" });
  }
  function $() {
    const v = /* @__PURE__ */ new Date();
    S(v.getHours() * 60 + v.getMinutes());
  }
  function I() {
    S(0);
  }
  const G = M(() => w.getViewEvents(p.value)), ne = w.createEvent, De = w.deleteEvent;
  return me(() => y.view, (v) => X(v, !1)), me(() => y.availableViews, ce), me(() => y.datePicker, () => X("month", !1)), me(() => y.viewDate, (v) => A(v, !1)), me(() => y.selectedDate, (v) => x(v, !1)), me(() => y.startWeekOnSunday, (v) => he(v)), me(() => y.hideWeekends, (v) => i(v)), me(() => y.hideWeekdays, T), me(() => D.value, () => {
    D.value > 90 && console.warn("Vue Cal: high cell count detected. Performance may degrade when interactions are enabled.");
  }), me(() => y.watchRealTime, (v) => {
    v && y.time ? E() : W = clearTimeout(W);
  }), se(), y.time && y.watchRealTime && E(), Xe(() => W = clearTimeout(W)), {
    now: u,
    id: f,
    broaderView: O,
    narrowerView: B,
    title: te,
    viewDate: m,
    start: q,
    end: t,
    extendedStart: o,
    // Full range, including out of scope month days, and hidden leading/trailing days.
    extendedEnd: e,
    // Full range, including out of scope month days, and hidden leading/trailing days.
    firstCellDate: l,
    lastCellDate: k,
    containsToday: h,
    selectedDate: F,
    cellDates: p,
    cols: L,
    rows: z,
    // All the events are stored and indexed in the events object of the eventsManager.
    // The following events array is only a subset of visible ones, plus any potential recurring
    // and multi-day events.
    events: G,
    transitionDirection: a,
    switch: X,
    broader: Ee,
    narrower: Q,
    previous: le,
    next: n,
    navigate: _,
    goToToday: g,
    updateViewDate: A,
    updateSelectedDate: x,
    scrollToCurrentTime: $,
    scrollToTime: S,
    scrollTop: I,
    createEvent: ne,
    deleteEvent: De,
    // Getters.
    get isDay() {
      return f.value === "day";
    },
    get isDays() {
      return f.value === "days";
    },
    get isWeek() {
      return f.value === "week";
    },
    get isMonth() {
      return f.value === "month";
    },
    get isYear() {
      return f.value === "year";
    },
    get isYears() {
      return f.value === "years";
    }
  };
}, lt = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"], rt = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], ot = "Years", it = "Year", ut = "Month", ct = "Week", dt = "Days", vt = "Day", mt = "Today", ft = "No Event", gt = "All day", ht = "Delete", yt = "Create an event", Dt = "dddd, MMMM D, YYYY", Ke = {
  weekDays: lt,
  months: rt,
  years: ot,
  year: it,
  month: ut,
  week: ct,
  days: dt,
  day: vt,
  today: mt,
  noEvent: ft,
  allDay: gt,
  deleteEvent: ht,
  createEvent: yt,
  dateFormat: Dt
}, Vt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  allDay: gt,
  createEvent: yt,
  dateFormat: Dt,
  day: vt,
  days: dt,
  default: Ke,
  deleteEvent: ht,
  month: ut,
  months: rt,
  noEvent: ft,
  today: mt,
  week: ct,
  weekDays: lt,
  year: it,
  years: ot
}, Symbol.toStringTag, { value: "Module" })), ze = $e({
  texts: { ...fe.texts },
  // Make texts reactive before a locale is loaded.
  dateUtils: st(fe.texts, Ke)
  // Some Date utils functions need localized texts.
}), Ot = ({ props: y, emit: s, attrs: r, vuecalEl: d, uid: w }) => {
  const b = $e({
    uid: w,
    // The Vuecal instance unique ID, used for dnd source-target identification.
    emit: s,
    texts: { ...ze.texts },
    // Make texts reactive before a locale is loaded.
    // The date utils composable.
    // A class/composable is needed in order to access the user locale in all the methods, and
    // independently of other potential Vue Cal instances on the same page.
    dateUtils: { ...ze.dateUtils },
    now: /* @__PURE__ */ new Date(),
    config: {},
    eventsManager: {},
    view: {},
    // At any time this object will be filled with current view details and visible events.
    dnd: {},
    // Drag and drop module.
    // stores the gesture related states. E.g. dragging event, resizing event, etc.
    touch: {
      isDraggingCell: !1,
      isDraggingEvent: !1,
      isResizingEvent: !1
    }
  });
  return b.dateUtils = st(Object.assign(fe.texts, b.texts), Ke), b.config = Yt(b, y, r), b.eventsManager = St(b), b.view = Ct(b, d), b.dnd = Et(b), b;
}, jt = 24 * 60, Ft = {
  allDayEvents: { type: [Boolean, String], default: !1 },
  // Coming soon.
  stackEvents: { type: Boolean, default: !1 },
  clickToNavigate: { type: Boolean, default: void 0 },
  // Setting to false will force it off on date-picker.
  dark: { type: Boolean, default: !1 },
  // Dark theme.
  datePicker: { type: Boolean, default: !1 },
  // Shorthand for xs: true, views: [month, year, years], clickToNavigate: true.
  disableDays: { type: Array, default: () => [] },
  // Array of specific dates to disable.
  // Can be true false or a finer grain permissions object like:
  // { drag: bool, resize: bool, create: bool, delete: bool }
  editableEvents: { type: [Boolean, Object], default: !1 },
  // Minimum drag distance in pixels to create an event (prevents accidental event creation when trying to navigate).
  eventCreateMinDrag: { type: Number, default: 15 },
  // The minimum drag distance in pixels to create an event.
  // The array of events to display in Vue Cal.
  // Can hold just the view events and be updated or the full array of all events available.
  events: { type: Array, default: () => [] },
  // Displays an events counter in each cell on month view or year view.
  // Can be a boolean or an array of views to display the event count on.
  eventCount: { type: [Boolean, Array], default: !1 },
  eventsOnMonthView: { type: Boolean, default: !1 },
  // Displays events in full on month view.
  hideWeekdays: { type: Array, default: () => [] },
  // An array of strings. Possible values: 'mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'.
  hideWeekends: { type: Boolean, default: !1 },
  // Show or hide both Saturday and Sunday in days, week and month views.
  // en-us is the default and fallback if locale is not supported.
  // The locale can also be provided externally to avoid using Promises.
  locale: { type: String, default: "" },
  // A language to use for all the texts.
  maxDate: { type: [String, Date], default: "" },
  // Mostly for date pickers, sets a maximum date for cell interactions.
  minDate: { type: [String, Date], default: "" },
  // Mostly for date pickers, sets a minimum date for cell interactions.
  // A 2-way binding that highlights the selected date in the calendar but does not navigate to it.
  selectedDate: { type: [String, Date], default: "" },
  // The selected date in the calendar !== viewDate.
  sm: { type: Boolean, default: !1 },
  // Small size (truncates texts + specific styles).
  specialHours: { type: Object, default: () => ({}) },
  // Highlight a particular time range on each day of the week, individually.
  schedules: { type: Array, default: () => [] },
  // Split a day in different persons/rooms/locations schedules.
  snapToInterval: { type: Number, default: 0 },
  // Snap the event start and end to a specific interval in minutes.
  startWeekOnSunday: { type: Boolean, default: !1 },
  // Shows Sunday before Monday in days, week and month views.
  theme: { type: [String, Boolean], default: "default" },
  // Only adds a CSS class when set to default.
  time: { type: Boolean, default: !0 },
  // Show or hide the time column.
  timeAtCursor: { type: Boolean, default: !1 },
  // Show or hide the "time at cursor" line.
  timeCellHeight: { type: Number, default: 40 },
  // In pixels.
  timeFormat: { type: String, default: "" },
  // Overrides the default time format.
  timeFrom: { type: Number, default: 0 },
  // Start time of the time column, in minutes.
  timeStep: { type: Number, default: 60 },
  // Step amount for the time in the time column, in minutes.
  timeTo: { type: Number, default: jt },
  // End time of the time column, in minutes.
  titleBar: { type: Boolean, default: !0 },
  // Show or hide the header title bar.
  todayButton: { type: Boolean, default: !0 },
  // Show or hide the header today button.
  twelveHour: { type: Boolean, default: !1 },
  // 12 or 24 hour format are respectively written like 1pm and 13:00.
  // Sets the calendar view to one of: 'day', 'days', 'week', 'month', 'year', 'years'. Default 'week' or 'month' if datePicker.
  // Gets updated on view navigation.
  view: { type: String, default: "" },
  viewDate: { type: [String, Date], default: "" },
  // The view will automatically set its start and end to present this date.
  // Only available for month and day views, this will shift the start of the view (left or right) by x days (signed integer).
  viewDayOffset: { type: Number, default: 0 },
  // The list of all the view that will be available in this calendar.
  // Default for normal layout: ['day', 'days', 'week', 'month', 'year', 'years'] }.
  // Default for date picker layout: ['month', 'year', 'years'].
  views: { type: [Array, Object] },
  viewsBar: { type: Boolean, default: !0 },
  // Show or hide the headers view selection bar.
  watchRealTime: { type: Boolean, default: !1 },
  // More expensive, so only trigger on demand.
  weekNumbers: { type: Boolean, default: !1 },
  // Show the weeks numbers in a column on month view.
  xs: { type: Boolean, default: !1 }
  // Extra small size for date pickers (truncates texts + specific styles).
  // TODO:
  // minEventWidth: { type: Number, default: 0 },
  // minScheduleWidth: { type: Number, default: 0 },
  // overlapsPerTimeStep: { type: Boolean, default: false },
  // resizeX: { type: Boolean, default: false },
}, Pt = { class: "vuecal__header" }, Lt = {
  key: 0,
  class: "vuecal__views-bar"
}, Ht = ["onClick", "innerHTML"], zt = {
  key: 1,
  class: "vuecal__title-bar"
}, Nt = { class: "vuecal__transition-wrap" }, Wt = ["disabled", "innerHTML"], At = {
  __name: "header",
  setup(y) {
    const s = Ne("vuecal"), { view: r, config: d } = s, w = () => {
      d.clickToNavigate && r.broader();
    }, b = M(() => d.clickToNavigate ? { click: w } : {});
    return (H, f) => (C(), j("div", Pt, [
      P(H.$slots, "header", {
        view: V(r),
        availableViews: V(d).availableViews,
        vuecal: V(s)
      }),
      H.$slots.header ? K("", !0) : (C(), j(re, { key: 0 }, [
        V(d).viewsBar ? (C(), j("div", Lt, [
          (C(!0), j(re, null, ke(V(d).availableViews, (F, u) => (C(), j("button", {
            class: ye(["vuecal__view-button", { "vuecal__view-button--active": V(r).id === u }]),
            onClick: (m) => V(r).switch(u),
            innerHTML: V(s).texts[u],
            type: "button"
          }, null, 10, Ht))), 256))
        ])) : K("", !0),
        V(d).titleBar ? (C(), j("nav", zt, [
          ge("button", {
            class: ye(["vuecal__nav vuecal__nav--prev", { "vuecal__nav--default": !H.$slots["previous-button"] }]),
            onClick: f[0] || (f[0] = (...F) => V(r).previous && V(r).previous(...F)),
            type: "button"
          }, [
            P(H.$slots, "previous-button")
          ], 2),
          ge("div", Nt, [
            Oe(Ge, {
              name: `vuecal-slide-fade--${V(r).transitionDirection}`
            }, {
              default: J(() => [
                (C(), j("div", {
                  key: V(r).id + V(r).start.getTime()
                }, [
                  H.$slots.title || H.$slots[`title.${V(r).id}`] ? (C(), Se(Qe(V(d).clickToNavigate && V(r).broaderView ? "button" : "div"), de({
                    key: 0,
                    class: "vuecal__title"
                  }, Be(b.value)), {
                    default: J(() => [
                      H.$slots[`title.${V(r).id}`] ? P(H.$slots, `title.${V(r).id}`, ee(de({ key: 0 }, V(r)))) : P(H.$slots, "title", ee(de({ key: 1 }, V(r))))
                    ]),
                    _: 3
                  }, 16)) : (C(), Se(Qe(V(d).clickToNavigate && V(r).broaderView ? "button" : "div"), de({
                    key: 1,
                    class: "vuecal__title"
                  }, Be(b.value), {
                    innerHTML: V(r).title
                  }), null, 16, ["innerHTML"]))
                ]))
              ]),
              _: 3
            }, 8, ["name"])
          ]),
          V(d).todayButton ? (C(), j(re, { key: 0 }, [
            H.$slots["today-button"] ? P(H.$slots, "today-button", {
              key: 0,
              navigate: () => !V(r).containsToday && V(r).goToToday(),
              active: V(r).containsToday
            }) : (C(), j("button", {
              key: 1,
              class: ye(["vuecal__nav vuecal__nav--today vuecal__nav--default", { "vuecal__nav--active": V(r).containsToday }]),
              onClick: f[1] || (f[1] = (F) => !V(r).containsToday && V(r).goToToday()),
              disabled: !!V(r).containsToday,
              type: "button",
              innerHTML: V(s).texts.today
            }, null, 10, Wt))
          ], 64)) : K("", !0),
          ge("button", {
            class: ye(["vuecal__nav vuecal__nav--next", { "vuecal__nav--default": !H.$slots["next-button"] }]),
            onClick: f[2] || (f[2] = (...F) => V(r).next && V(r).next(...F)),
            type: "button"
          }, [
            P(H.$slots, "next-button")
          ], 2)
        ])) : K("", !0)
      ], 64))
    ]));
  }
}, It = {
  key: 0,
  class: "vuecal__headings"
}, Bt = {
  key: 0,
  class: "vuecal__weekdays-headings"
}, Rt = ["onClick"], Xt = { class: "vuecal__weekday-day" }, Gt = {
  key: 0,
  class: "vuecal__weekday-date"
}, Jt = {
  key: 1,
  class: "vuecal__schedules-headings w-flex grow"
}, Ut = ["innerHTML"], qt = {
  __name: "headings-bar",
  setup(y) {
    const s = Ne("vuecal"), { view: r, config: d, dateUtils: w } = s, b = M(() => d.xs ? "day-xs" : d.sm || r.isDays || r.isMonth ? "day-sm" : "day"), H = M(() => (r.isDay || r.isDays || r.isWeek || r.isMonth) && !(r.isDay && !d.schedules)), f = M(() => r.cellDates.slice(0, r.cols).map(({ start: u }) => ({
      id: Re[u.getDay()],
      date: u,
      dateNumber: u.getDate(),
      day: w.formatDate(u, "dddd"),
      "day-sm": w.formatDate(u, "ddd"),
      "day-xs": w.formatDate(u, "dd"),
      isToday: w.isToday(u)
    }))), F = {
      click: (u) => {
        (r.isDays || r.isWeek) && r.updateSelectedDate(u);
      }
    };
    return (u, m) => H.value ? (C(), j("div", It, [
      V(r).isDay ? K("", !0) : (C(), j("div", Bt, [
        (C(!0), j(re, null, ke(f.value, (Y, W) => (C(), j("div", {
          class: ye(["vuecal__weekday", { "vuecal__weekday--today": Y.isToday }]),
          key: W,
          onClick: (q) => F.click(Y.date)
        }, [
          P(u.$slots, "weekday-heading", {
            label: Y[b.value],
            id: Y.id,
            date: Y.date
          }, () => [
            ge("span", Xt, ie(Y[b.value]), 1),
            V(r).isMonth ? K("", !0) : (C(), j("strong", Gt, ie(Y.dateNumber), 1))
          ])
        ], 10, Rt))), 128))
      ])),
      V(d).schedules ? (C(), j("div", Jt, [
        (C(!0), j(re, null, ke(f.value, (Y, W) => (C(), j(re, { key: W }, [
          (C(!0), j(re, null, ke(V(d).schedules, (q, t) => (C(), j(re, { key: t }, [
            u.$slots["schedule-heading"] ? (C(), j("div", {
              key: 0,
              class: ye(["vuecal__schedule vuecal__schedule--heading", q.class])
            }, [
              P(u.$slots, "schedule-heading", {
                schedule: q,
                view: V(r)
              })
            ], 2)) : (C(), j("div", {
              key: 1,
              class: ye(["vuecal__schedule vuecal__schedule--heading", q.class]),
              innerHTML: q.label
            }, null, 10, Ut))
          ], 64))), 128))
        ], 64))), 128))
      ])) : K("", !0)
    ])) : K("", !0);
  }
}, Zt = { class: "vuecal__time-column" }, Kt = {
  __name: "time-column",
  setup(y) {
    const s = Ne("vuecal"), { config: r, texts: d } = s, w = M(() => {
      const b = [];
      for (let f = r.timeFrom; f < r.timeTo; f += r.timeStep) {
        const F = f + r.timeStep > r.timeTo, u = ~~(f / 60), m = f % 60, Y = d[f < 720 ? "am" : "pm"];
        let W = null;
        F && (W = `calc(var(--vuecal-time-cell-height) * ${(r.timeTo - f) / r.timeStep})`), b.push({
          minutesSum: f,
          // The sum of hours + minutes in minutes.
          hours: u,
          minutes: m,
          formatted12: `${u % 12 ? u % 12 : 12}${m ? `:${m.toString().padStart(2, 0)}` : ""}${Y}`,
          formatted24: `${u.toString().padStart(2, 0)}:${m.toString().padStart(2, 0)}`,
          height: W
        });
      }
      return b;
    });
    return (b, H) => (C(), j("div", Zt, [
      (C(!0), j(re, null, ke(w.value, (f, F) => (C(), j("div", {
        class: "vuecal__time-cell",
        key: F,
        style: _e({ height: f.height || null })
      }, [
        P(b.$slots, "time-cell", {
          index: F,
          minutes: f.minutes,
          hours: f.hours,
          minutesSum: f.minutesSum,
          format12: f.formatted12,
          format24: f.formatted24
        }, () => [
          ge("label", null, ie(V(r).twelveHour ? f.formatted12 : f.formatted24), 1)
        ])
      ], 4))), 128))
    ]));
  }
}, Qt = ["draggable"], xt = { class: "vuecal__event-details" }, ea = { class: "vuecal__event-title" }, ta = {
  key: 0,
  class: "vuecal__event-time"
}, aa = ["innerHTML"], nt = {
  __name: "event",
  props: {
    event: { type: Object, required: !0 }
  },
  emits: ["event-drag-start", "event-drag-end", "event-resize-start", "event-resize-end"],
  setup(y, { emit: s }) {
    const { config: r, view: d, dnd: w, touch: b, dateUtils: H } = Ne("vuecal"), f = y, F = ue(null), u = $e(f.event), m = $e({
      dragging: !1,
      resizing: !1,
      fromResizer: !1,
      // If the drag originates from the resizer element.
      holding: !1,
      // When the event is clicked and hold for a certain amount of time.
      holdTimer: null,
      // event click and hold detection.
      startX: 0,
      // The X coords at the start of the drag.
      startY: 0,
      // The Y coords at the start of the drag.
      startPercentageX: 0,
      // The X coords in percentage at the start of the drag.
      startPercentageY: 0,
      // The Y coords in percentage at the start of the drag.
      moveX: 0,
      // The X coords while dragging.
      moveY: 0,
      // The Y coords while dragging.
      movePercentageX: 0,
      // The X coords in percentage while dragging.
      movePercentageY: 0,
      // The Y coords in percentage while dragging.
      resizeStartDate: null,
      // When resizing and going above the start date (end before start) update the start instead of the end.
      resizingOriginalEvent: null,
      // Store the original event details while resizing.
      resizingLastAcceptedEvent: null,
      // Store the last accepted event details while resizing.
      cellEl: null,
      // Store the cell DOM node for a more efficient resizing calc in mousemove/touchmove.
      schedule: null
    }), Y = M(() => r.editableEvents.drag && u.draggable !== !1 && !u.background), W = M(() => d.isMonth || d.isYear || d.isYears ? !1 : r.time && r.editableEvents.resize && u.resizable !== !1 && !u.background);
    M(() => r.editableEvents.delete && u.deletable !== !1 && !u.background);
    const q = M(() => {
      var D, l, p;
      return {
        [`vuecal__event--${u._.id}`]: !0,
        [u.class]: !!u.class,
        "vuecal__event--recurring": !!u.recurring,
        "vuecal__event--background": !!u.background,
        "vuecal__event--multiday": !!((D = u._) != null && D.multiday),
        "vuecal__event--cut-top": ((l = u._) == null ? void 0 : l.startMinutes) < r.timeFrom,
        "vuecal__event--cut-bottom": ((p = u._) == null ? void 0 : p.endMinutes) > r.timeTo || u.end.getDate() !== u.start.getDate(),
        // Only apply the dragging class on the event copy that is being dragged.
        "vuecal__event--dragging": !u._.draggingGhost && u._.dragging,
        // Only apply the dragging-ghost class on the event original that remains fixed while a copy is being
        // dragged. Sometimes when dragging fast the dragging-ghost class would get stuck and events stays
        // invisible, so if dragging is false, disable the dragging-ghost class as well.
        // On event drop, if the new position of the event is approved, only remove the dragging-ghost class
        // after event deletion (event._.dragging is already false) so the event ghost does not flash in before
        // deletion.
        "vuecal__event--dragging-ghost": u._.draggingGhost,
        "vuecal__event--resizing": m.resizing
      };
    }), t = M(() => {
      const D = (d.isDay || d.isDays || d.isWeek) && r.time;
      if (!D && !u.backgroundColor && !u.color) return !1;
      const l = {
        backgroundColor: u.backgroundColor || null,
        color: u.color || null
      };
      if (D) {
        const p = Math.max(r.timeFrom, u._.startMinutes), k = Math.min(r.timeTo, u._.endMinutes), a = Ve(p, r), O = Ve(k, r) - a;
        l.top = `${a}%`, l.height = `${O}%`;
      }
      return l;
    }), o = M(() => {
      const D = { ...r.eventListeners.event };
      for (const [k, a] of Object.entries(D))
        ["resize-end"].includes(k) || (D[k] = (O) => {
          O.type !== "drop" && a(O.type ? { e: O, event: u } : O);
        });
      const l = { ...D };
      D.touchstart = (k) => {
        var a;
        k.stopPropagation(), e(k), (a = l.touchstart) == null || a.call(l, { e: k, event: u });
      }, D.mousedown = (k) => {
        var a;
        k.stopPropagation(), e(k), (a = l.mousedown) == null || a.call(l, { e: k, event: u });
      };
      let p = null;
      return D.click = (k) => {
        var a;
        (a = l.click) == null || a.call(l, { e: k, event: u }), p ? p = clearTimeout(p) : p = setTimeout(() => {
          var O;
          p = null, (O = l["delayed-click"]) == null || O.call(l, { e: k, event: u });
        }, 400);
      }, D.dblclick = (k) => {
        l.dblclick ? l.dblclick({ e: k, event: u }) : u.delete(1);
      }, D;
    }), e = (D) => {
      var k, a, O;
      const l = ((k = D.touches) == null ? void 0 : k[0]) || D;
      m.fromResizer = l.target.matches(".vuecal__event-resizer, .vuecal__event-resizer *");
      const p = F.value.getBoundingClientRect();
      m.startX = (((a = D.touches) == null ? void 0 : a[0]) || D).clientX - p.left, m.startY = (((O = D.touches) == null ? void 0 : O[0]) || D).clientY - p.top, m.startPercentageX = m.startX * 100 / p.width, m.startPercentageY = m.startY * 100 / p.height, m.cellEl = F.value.closest(".vuecal__cell"), m.resizeStartDate = u.start, z(D.type === "touchstart" ? "touchmove" : "mousemove", h), z(D.type === "touchstart" ? "touchend" : "mouseup", c, { once: !0 }), m.holdTimer = setTimeout(() => {
        var B, R;
        m.holding = !0, (R = (B = o.value).hold) == null || R.call(B, { e: D, event: u });
      }, 1e3);
    }, h = async (D) => {
      var p, k, a, O;
      const l = ((p = D.touches) == null ? void 0 : p[0]) || D;
      if (m.fromResizer && !m.resizing && (m.resizing = !0, m.resizingOriginalEvent = { ...u, _: { ...u._ } }, b.isResizingEvent = !0, (a = (k = o.value).resizeStart) == null || a.call(k, { e: D, event: u })), m.holdTimer = clearTimeout(m.holdTimer), m.holding = !1, m.cellEl) {
        const { top: B, left: R, width: oe, height: te } = m.cellEl.getBoundingClientRect();
        m.moveX = l.clientX - R, m.moveY = l.clientY - B, m.movePercentageX = m.moveX * 100 / oe, m.movePercentageY = m.moveY * 100 / te;
      }
      if (m.fromResizer) {
        const { newStart: B, newEnd: R } = E(u);
        let oe = !0;
        const { resize: te } = (O = r.eventListeners) == null ? void 0 : O.event;
        te && (oe = await te({
          e: D,
          event: { ...u, start: B, end: R },
          overlaps: u.getOverlappingEvents({ start: B, end: R })
        })), oe !== !1 ? (u.start = B, u.end = R, m.resizingLastAcceptedEvent && (m.resizingLastAcceptedEvent = null)) : te && (m.resizingLastAcceptedEvent = { ...u, _: { ...u._ } });
      }
    }, c = async (D) => {
      var l, p;
      if (m.holdTimer = clearTimeout(m.holdTimer), m.holding = !1, m.resizing) {
        const { newStart: k, newEnd: a } = E(u);
        let O = !0;
        const B = o.value["resize-end"];
        B && (O = await B({
          e: D,
          event: u,
          original: m.resizingOriginalEvent,
          // Original event details before resizing.
          overlaps: u.getOverlappingEvents({ start: k, end: a })
        })), u.start = O === !1 ? (m.resizingLastAcceptedEvent || m.resizingOriginalEvent).start : ((l = m.resizingLastAcceptedEvent) == null ? void 0 : l.start) || k, u.end = O === !1 ? (m.resizingLastAcceptedEvent || m.resizingOriginalEvent).end : ((p = m.resizingLastAcceptedEvent) == null ? void 0 : p.end) || a, u._.duration < 1 && (u.start = m.resizingOriginalEvent.start, u.end = m.resizingOriginalEvent.end), b.isResizingEvent = !1;
      }
      document.removeEventListener(D.type === "touchend" ? "touchmove" : "mousemove", h), m.resizing = !1, m.fromResizer = !1, m.dragging = !1, m.startX = 0, m.startY = 0, m.moveX = 0, m.moveY = 0, m.startPercentageX = 0, m.startPercentageY = 0, m.movePercentageX = 0, m.movePercentageY = 0, m.cellEl = null, m.resizeStartDate = null, m.resizingOriginalEvent = null, m.resizingLastAcceptedEvent = null, m.schedule = null;
    }, E = (D) => {
      const l = new Date(D.start.getFullYear(), D.start.getMonth(), D.start.getDate());
      new Date(l).setDate(l.getDate() + 1);
      let k = Fe(m.movePercentageY, r);
      if (k = Math.max(0, Math.min(k, 24 * 60)), r.snapToInterval) {
        const B = k + r.snapToInterval / 2;
        k = B - B % r.snapToInterval;
      }
      let a = D.start, O = new Date(l.getTime() + k * 6e4);
      return O < m.resizeStartDate && (a = O, O = m.resizeStartDate), { newStart: a, newEnd: O };
    };
    qe(() => u._.register(F.value));
    const L = [], z = (D, l, p) => {
      document.addEventListener(D, l, p), L.push({ event: D, handler: l, options: p });
    };
    return Xe(() => {
      u._.unregister();
      for (const { event: D, handler: l, options: p } of L)
        document.removeEventListener(D, l, p);
    }), (D, l) => (C(), j("div", de({ class: "vuecal__event" }, Be(o.value, !0), {
      ref_key: "eventEl",
      ref: F,
      class: q.value,
      style: t.value,
      draggable: Y.value ? "true" : void 0,
      onDragstart: l[2] || (l[2] = (p) => Y.value && V(w).eventDragStart(p, u)),
      onDragend: l[3] || (l[3] = (p) => Y.value && V(w).eventDragEnd(p, u))
    }), [
      ge("div", xt, [
        P(D.$slots, "event", { event: u }, () => [
          ge("div", ea, ie(u.title), 1),
          V(r).time ? (C(), j("div", ta, ie(u._[`startTimeFormatted${V(r).twelveHour ? 12 : 24}`]) + `
- ` + ie(u._[`endTimeFormatted${V(r).twelveHour ? 12 : 24}`]), 1)) : K("", !0),
          ge("div", {
            class: "vuecal__event-content",
            innerHTML: u.content
          }, null, 8, aa)
        ])
      ]),
      W.value ? (C(), j("div", {
        key: 0,
        class: "vuecal__event-resizer",
        onDragstart: l[0] || (l[0] = xe(() => {
        }, ["prevent", "stop"]))
      }, null, 32)) : K("", !0),
      Oe(Ge, { name: "vuecal-delete-btn" }, {
        default: J(() => [
          u._.deleting ? (C(), j("div", {
            key: 0,
            class: "vuecal__event-delete",
            onClick: l[1] || (l[1] = xe((p) => u.delete(3), ["stop"]))
          }, "Delete")) : K("", !0)
        ]),
        _: 1
      })
    ], 16, Qt));
  }
}, na = ["innerHTML"], sa = ["data-schedule"], la = {
  key: 1,
  class: "vuecal__cell-date"
}, ra = {
  key: 2,
  class: "vuecal__cell-content"
}, oa = {
  key: 3,
  class: "vuecal__cell-events"
}, ia = {
  key: 1,
  class: "vuecal__cell-date"
}, ua = {
  key: 2,
  class: "vuecal__cell-content"
}, ca = {
  key: 3,
  class: "vuecal__cell-events"
}, da = {
  key: 5,
  class: "vuecal__cell-events-count"
}, va = ["title"], ma = {
  __name: "cell",
  props: {
    // Even with time=false, the date of the cell will still be provided in order to attach
    // events to a specific date.
    start: { type: Date, required: !0 },
    end: { type: Date, required: !0 },
    index: { type: Number, required: !0 }
  },
  setup(y) {
    const s = y, r = Ne("vuecal"), { view: d, config: w, dateUtils: b, eventsManager: H, dnd: f, touch: F } = r, u = M(() => b.isToday(s.start)), m = ue(null), Y = ue([]), W = ue(!1), q = (i) => {
      Y.value.push(i.detail), W.value = !0;
    }, t = () => setTimeout(() => W.value = !1, 300), o = $e({
      dragging: !1,
      holding: !1,
      // When the cell is clicked and hold for a certain amount of time.
      holdTimer: null,
      // Cell click and hold detection.
      thresholdPassed: !1,
      // If the drag threshold has been passed.
      startX: 0,
      // The x position at the start of the drag (mousedown or touchstart).
      startY: 0,
      // The y position at the start of the drag (mousedown or touchstart).
      moveX: 0,
      moveY: 0,
      startPercentageX: 0,
      // The x position in percentage at the start of the drag (mousedown or touchstart).
      startPercentageY: 0,
      // The y position in percentage at the start of the drag (mousedown or touchstart).
      movePercentageX: 0,
      movePercentageY: 0,
      schedule: null
    }), e = ue(!1), h = ue({ cellOverlaps: {}, longestStreak: 0 }), c = M(() => {
      let i = Math.min(o.startPercentageY, o.movePercentageY), T = Math.max(o.startPercentageY, o.movePercentageY), S = Fe(i, w), $ = Fe(T, w);
      return w.snapToInterval && (S = b.snapToInterval(S, w.snapToInterval), $ = b.snapToInterval($, w.snapToInterval), i = Ve(S, w), T = Ve($, w)), {
        style: {
          top: `${i}%`,
          height: `${Math.abs(T - i)}%`
        },
        startMinutes: S,
        endMinutes: $,
        start: b.formatMinutes(S),
        end: b.formatMinutes($),
        ...o.schedule ? { schedule: o.schedule } : {}
      };
    }), E = M(() => {
      const i = w.editableEvents.create && (o.dragging || e.value), T = w.eventCreateMinDrag && o.thresholdPassed || !w.eventCreateMinDrag;
      return i && T;
    }), L = M(() => {
      var ne;
      const i = /* @__PURE__ */ new Date(), T = d.start.getFullYear(), S = d.start.getMonth(), $ = s.start.getFullYear(), I = s.start.getMonth();
      return {
        [`vuecal__cell--${Re[s.start.getDay()]}`]: d.isDay || d.isDays || d.isWeek || d.isMonth,
        [`vuecal__cell--${Tt[I]}`]: d.isYear,
        [`vuecal__cell--${$}`]: d.isYears,
        "vuecal__cell--today": u.value,
        "vuecal__cell--current-month": d.isYear && $ === i.getFullYear() && I === i.getMonth(),
        "vuecal__cell--current-year": d.isYears && $ === i.getFullYear(),
        "vuecal__cell--out-of-range": d.isMonth && ($ !== T || I !== S),
        "vuecal__cell--before-min": te.value && R.value,
        "vuecal__cell--after-max": te.value && oe.value,
        "vuecal__cell--disabled": te.value,
        "vuecal__cell--selected": d.selectedDate && d.selectedDate.getTime() >= s.start.getTime() && d.selectedDate.getTime() <= s.end.getTime(),
        "vuecal__cell--has-schedules": (ne = w.schedules) == null ? void 0 : ne.length,
        "vuecal__cell--dragging": o.dragging,
        "vuecal__cell--has-events": D.value.length
      };
    });
    M(() => b.formatDate(s.start));
    const z = M(() => {
      switch (d.id) {
        case "day":
          return "";
        case "days":
          return w.availableViews.days.rows > 1 && b.formatDate(s.start, "D"), "";
        case "week":
          return "";
        case "month":
          return b.formatDate(s.start, "D");
        case "year":
          return b.formatDate(s.start, w.xs ? "MMM" : "MMMM");
        case "years":
          return b.formatDate(s.start, "YYYY");
      }
    }), D = M(() => w.datePicker ? [] : H.getEventsInRange(s.start, s.end, { excludeIds: Y.value })), l = M(() => D.value.filter((i) => !i.background)), p = M(() => {
      var i;
      return (i = w.schedules) == null ? void 0 : i.reduce((T, S) => (T[S.id] = D.value.filter(($) => $.schedule === S.id), T), {});
    }), k = M(() => {
      if (d.isMonth || d.isYear || d.isYears) return {};
      const i = {};
      for (const T of D.value) {
        const S = T._.id, { maxConcurrent: $ = 1, position: I = 0 } = h.value.cellOverlaps[S] || {};
        i[S] = { left: `${100 / $ * I}%` }, w.stackEvents ? i[S].width = `${100 / $ + (I === $ - 1 ? 0 : 15)}%` : i[S].width = `${100 / $}%`;
      }
      return i;
    }), a = M(() => {
      const i = {};
      for (const T of D.value) {
        const S = T._.id, { maxConcurrent: $ = 1, position: I = 0 } = h.value.cellOverlaps[S] || {};
        i[S] = `vuecal__event--stack-${I + 1}-${$}`;
      }
      return i;
    }), O = M(() => w.showCellEventCount && l.value.length), B = M(() => {
      var S;
      if (!w.specialHours || d.isMonth || d.isYear || d.isYears) return;
      const i = Re[s.start.getDay()];
      let T = (S = w.specialHours) == null ? void 0 : S[i];
      if (T)
        return Array.isArray(T) || (T = [T]), T.map(($) => {
          let { from: I, to: G, class: ne, label: De } = $;
          if (isNaN(I) || isNaN(G) || w.timeFrom >= G || w.timeTo <= I) return;
          I = Math.max(w.timeFrom, I), G = Math.min(w.timeTo, G);
          const v = Ve(I, w), N = Ve(G, w) - v;
          return {
            style: { top: `${v}%`, height: `${N}%` },
            label: De,
            class: ne
          };
        }).filter(($) => !!$);
    }), R = M(() => w.minTimestamp !== null && w.minTimestamp > s.end.getTime()), oe = M(() => w.maxTimestamp && w.maxTimestamp < s.start.getTime()), te = M(() => {
      const { disableDays: i } = w, T = d.isYear || d.isYears;
      return i.length && i.includes(b.formatDate(s.start)) && !T ? !0 : R.value || oe.value;
    }), se = $e({
      show: M(() => {
        if (!(!d.isDay && !d.isDays && !d.isWeek) && !(!u.value || !w.time) && !(w.timeFrom > b.dateToMinutes(d.now)) && !(b.dateToMinutes(d.now) > w.timeTo))
          return !0;
      }),
      nowInMinutes: M(() => b.dateToMinutes(d.now)),
      todaysTimePosition: M(() => Ve(se.nowInMinutes, w)),
      style: M(() => `top: ${se.todaysTimePosition}%`),
      currentTime: M(() => b.formatTime(d.now))
    }), ce = M(() => {
      if (te.value) return {};
      const i = { ...w.eventListeners.cell };
      for (const [$, I] of Object.entries(i))
        i[$] = (G) => {
          var ne, De, v;
          (v = (De = G.target || ((ne = G.e) == null ? void 0 : ne.target)).closest) != null && v.call(De, ".vuecal__event") || I(G.type ? { e: G, cell: X.value, cursor: Q.value } : G);
        };
      const T = { ...i };
      let S = null;
      return i.click = ($) => {
        var G;
        le();
        const I = Ee($);
        (G = T.click) == null || G.call(T, { e: $, cell: X.value, cursor: I }), S ? S = clearTimeout(S) : S = setTimeout(() => {
          var ne;
          S = null, (ne = T["delayed-click"]) == null || ne.call(T, { e: $, cell: X.value, cursor: I });
        }, 400);
      }, (w.time && d.isDay || d.isDays || d.isWeek) && (i.touchstart = ($) => {
        var I;
        n($.e || $), (I = T.touchstart) == null || I.call(T, { e: $, cell: X.value, cursor: Q.value });
      }, i.mousedown = ($) => {
        var I;
        n($.e || $), (I = T.mousedown) == null || I.call(T, { e: $, cell: X.value, cursor: Q.value });
      }), T.dblclick && (i.dblclick = ($) => {
        var I;
        (I = T.dblclick) == null || I.call(T, { e: $, cell: X.value, cursor: Ee($) });
      }), w.editableEvents.drag && (i.dragenter = ($) => f.cellDragEnter($, X.value), i.dragover = ($) => {
        $.preventDefault(), f.cellDragOver($, X.value);
      }, i.dragleave = ($) => f.cellDragLeave($, X.value), i.drop = ($) => f.cellDragDrop($, X.value)), i;
    }), X = M(() => ({
      start: s.start,
      end: s.end,
      events: D,
      ...o.schedule ? { schedule: o.schedule } : {},
      goNarrower: () => d.narrower(),
      goBroader: () => d.broader(),
      broader: d.broaderView,
      narrower: d.narrowerView
    })), Ee = (i) => {
      var G;
      const T = (((G = i.touches) == null ? void 0 : G[0]) || i).clientY, { top: S } = m.value.getBoundingClientRect(), $ = Ze(T - S, m.value), I = new Date(s.start);
      return I.setMinutes(Fe($, w)), { y: $, date: I };
    }, Q = M(() => {
      const i = Fe(o.movePercentageY || o.startPercentageY, w), T = new Date(s.start);
      return T.setMinutes(i), {
        x: o.movePercentageX || o.startPercentageX,
        y: o.movePercentageY || o.startPercentageY,
        date: T
      };
    }), le = () => {
      d.updateSelectedDate(s.start), w.clickToNavigate && ((d.isMonth || d.isDays || d.isWeek) && w.availableViews.day ? d.switch("day") : d.isYear && w.availableViews.month ? d.switch("month") : d.isYears && w.availableViews.year && d.switch("year")), d.updateViewDate(s.start);
    }, n = (i) => {
      var S, $;
      o.schedule = ~~i.target.dataset.schedule;
      const T = m.value.getBoundingClientRect();
      o.startX = (((S = i.touches) == null ? void 0 : S[0]) || i).clientX - T.left, o.startY = ((($ = i.touches) == null ? void 0 : $[0]) || i).clientY - T.top, o.startPercentageX = o.startX * 100 / T.width, o.startPercentageY = o.startY * 100 / T.height, o.thresholdPassed = !1, document.addEventListener(i.type === "touchstart" ? "touchmove" : "mousemove", _), document.addEventListener(i.type === "touchstart" ? "touchend" : "mouseup", g, { once: !0 }), o.holdTimer = setTimeout(() => {
        var I, G;
        o.holding = !0, (G = (I = ce.value).hold) == null || G.call(I, { e: i, cell: X.value, cursor: Q.value });
      }, 1e3);
    }, _ = (i) => {
      var S, $, I, G, ne, De;
      o.dragging || (F.isDraggingCell = !0, ($ = (S = ce.value)["drag-start"]) == null || $.call(S, { e: i, cell: X.value, cursor: Q.value })), o.dragging = !0, o.holdTimer = clearTimeout(o.holdTimer), o.holding = !1;
      const T = m.value.getBoundingClientRect();
      o.moveX = (((I = i.touches) == null ? void 0 : I[0]) || i).clientX - T.left, o.moveY = (((G = i.touches) == null ? void 0 : G[0]) || i).clientY - T.top, o.movePercentageX = o.moveX * 100 / T.width, o.movePercentageY = o.moveY * 100 / T.height, w.eventCreateMinDrag && Math.abs(o.startY - o.moveY) > w.eventCreateMinDrag && (o.thresholdPassed = !0), (De = (ne = ce.value).drag) == null || De.call(ne, { e: i, cell: X.value, cursor: Q.value });
    }, g = async (i) => {
      var T, S;
      document.removeEventListener(i.type === "touchend" ? "touchmove" : "mousemove", _, { passive: !1 }), o.dragging && ((S = (T = ce.value)["drag-end"]) == null || S.call(T, { e: i, cell: X.value, cursor: Q.value }), F.isDraggingCell = !1, w.editableEvents.create && (e.value = !0, await A(i), e.value = !1)), o.holdTimer = clearTimeout(o.holdTimer), o.holding = !1, o.dragging = !1, o.startX = 0, o.startY = 0, o.moveX = 0, o.moveY = 0, o.startPercentageX = 0, o.startPercentageY = 0, o.movePercentageX = 0, o.movePercentageY = 0, o.thresholdPassed = !1, o.schedule = null;
    }, A = async (i) => {
      if (!E.value) return;
      let { start: T, end: S, startMinutes: $, endMinutes: I } = c.value;
      T = new Date(s.start), T.setMinutes($), S = new Date(s.start), S.setMinutes(I);
      let G = { ...c.value, start: T, end: S };
      const { create: ne } = w.eventListeners.event;
      if (typeof ne == "function") {
        const De = G;
        G = await new Promise((v) => ne({ e: i, event: G, cell: X.value, resolve: v, cursor: Q.value })), G && typeof G == "object" && d.createEvent(G), G && typeof G == "boolean" && d.createEvent(De);
      } else d.createEvent(G);
    }, x = () => {
      var i;
      for (const T of Object.keys(ce.value))
        (i = m.value) == null || i.removeEventListener(T, ce.value[T]);
    }, he = () => {
      h.value = H.getCellOverlappingEvents(s.start, s.end);
    };
    return me(
      // Watch event IDs and start/end dates (only) to detect event resizing/dnd.
      () => !d.isYears && !d.isYear && l.value.map((i) => `${i._.id}${i.start.getTime()}${i.end.getTime()}`).join(),
      async () => {
        await Ue(), he();
      },
      { immediate: !0, flush: "post" }
      // Use flush: 'post' to prevent infinite updates.
    ), Xe(async () => {
      for (const i of Y.value) H.deleteEvent(i, 3);
      x(), await Ue();
    }), (i, T) => (C(), j("div", de({
      class: ["vuecal__cell", L.value],
      ref_key: "cellEl",
      ref: m
    }, Be(ce.value, !0)), [
      i.$slots.cell ? P(i.$slots, "cell", {
        key: 0,
        cell: X.value
      }) : K("", !0),
      B.value ? (C(!0), j(re, { key: 1 }, ke(B.value, (S, $) => (C(), j("div", {
        class: ye(["vuecal__special-hours", S.class]),
        style: _e(S.style),
        innerHTML: S.label || ""
      }, null, 14, na))), 256)) : K("", !0),
      !i.$slots.cell && V(w).schedules ? (C(!0), j(re, { key: 2 }, ke(V(w).schedules, (S) => (C(), j("div", {
        class: ye(["vuecal__schedule vuecal__schedule--cell", S.class]),
        key: S.id,
        style: _e(S.style || null),
        "data-schedule": S.id
      }, [
        i.$slots["cell-events"] ? P(i.$slots, "cell-events", {
          key: 0,
          cell: X.value
        }) : K("", !0),
        z.value || i.$slots["cell-date"] ? (C(), j("div", la, [
          P(i.$slots, "cell-date", { cell: X.value }, () => [
            et(ie(z.value), 1)
          ])
        ])) : K("", !0),
        i.$slots["cell-content"] ? (C(), j("div", ra, [
          P(i.$slots, "cell-content", { cell: X.value })
        ])) : K("", !0),
        i.$slots["cell-events"] && D.value.length ? (C(), j("div", oa, [
          P(i.$slots, "cell-events", { cell: X.value })
        ])) : D.value.length || W.value ? (C(), Se(tt, {
          key: 4,
          class: "vuecal__cell-events",
          name: "vuecal-event-delete",
          onBeforeLeave: T[0] || (T[0] = ($) => W.value = !0),
          onAfterLeave: t,
          tag: "div"
        }, {
          default: J(() => [
            (C(!0), j(re, null, ke(p.value[S.id], ($) => (C(), Se(nt, {
              key: $._.id,
              event: $,
              onEventDeleted: q,
              style: _e(k.value[$._.id])
            }, je({ _: 2 }, [
              i.$slots.event ? {
                name: "event",
                fn: J((I) => [
                  P(i.$slots, "event", de({ ref_for: !0 }, I))
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["event", "style"]))), 128))
          ]),
          _: 2
        }, 1024)) : K("", !0),
        E.value && o.schedule === S.id ? (C(), j("div", {
          key: 5,
          class: "vuecal__event-placeholder",
          style: _e(c.value.style)
        }, ie(c.value.start) + " - " + ie(c.value.end), 5)) : K("", !0)
      ], 14, sa))), 128)) : K("", !0),
      !i.$slots.cell && !V(w).schedules ? (C(), j(re, { key: 3 }, [
        i.$slots["cell-events"] ? P(i.$slots, "cell-events", {
          key: 0,
          cell: X.value
        }) : K("", !0),
        z.value || i.$slots["cell-date"] ? (C(), j("div", ia, [
          P(i.$slots, "cell-date", { cell: X.value }, () => [
            et(ie(z.value), 1)
          ])
        ])) : K("", !0),
        i.$slots["cell-content"] ? (C(), j("div", ua, [
          P(i.$slots, "cell-content", { cell: X.value })
        ])) : K("", !0),
        i.$slots["cell-events"] && D.value.length ? (C(), j("div", ca, [
          P(i.$slots, "cell-events", { cell: X.value })
        ])) : !(V(d).isMonth && !V(w).eventsOnMonthView) && !V(d).isYear && !V(d).isYears && (D.value.length || W.value) ? (C(), Se(tt, {
          key: 4,
          class: "vuecal__cell-events",
          name: "vuecal-event-delete",
          onBeforeLeave: T[1] || (T[1] = (S) => W.value = !0),
          onAfterLeave: t,
          tag: "div"
        }, {
          default: J(() => [
            (C(!0), j(re, null, ke(D.value, (S) => (C(), Se(nt, {
              key: S._.id,
              event: S,
              onEventDeleted: q,
              class: ye(a.value[S._.id]),
              style: _e(k.value[S._.id])
            }, je({ _: 2 }, [
              i.$slots.event ? {
                name: "event",
                fn: J(($) => [
                  P(i.$slots, "event", de({ ref_for: !0 }, $))
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["event", "class", "style"]))), 128))
          ]),
          _: 3
        })) : K("", !0),
        E.value ? (C(), j("div", {
          key: 5,
          class: "vuecal__event-placeholder",
          style: _e(c.value.style)
        }, ie(c.value.start) + " - " + ie(c.value.end), 5)) : K("", !0)
      ], 64)) : K("", !0),
      i.$slots["event-count"] ? P(i.$slots, "event-count", {
        key: 4,
        events: l.value
      }) : O.value ? (C(), j("div", da, ie(l.value.length), 1)) : K("", !0),
      se.show ? (C(), j("div", {
        key: 6,
        class: "vuecal__now-line",
        style: _e(se.style),
        title: se.currentTime
      }, [
        ge("span", null, ie(se.currentTime), 1)
      ], 12, va)) : K("", !0)
    ], 16));
  }
}, fa = {
  __name: "body",
  setup(y) {
    const s = Ne("vuecal"), { view: r, config: d, dateUtils: w } = s, b = ue(null), H = ue(null), f = M(() => ({
      "--vuecal-grid-columns": r.cols,
      "--vuecal-grid-rows": r.rows
    })), F = M(() => {
      const Y = w.formatTime(Fe(H.value, d));
      return {
        style: { top: `${H.value}%` },
        time: Y
      };
    }), u = (Y) => {
      var t;
      if (r.isMonth || r.isYear || r.isYears) return;
      const W = (((t = Y.touches) == null ? void 0 : t[0]) || Y).clientY, { top: q } = b.value.getBoundingClientRect();
      H.value = Ze(W - q, b.value);
    }, m = () => {
      H.value = null;
    };
    return qe(() => {
      b.value.addEventListener("mousemove", u), b.value.addEventListener("touchmove", u), b.value.addEventListener("mouseleave", m), b.value.addEventListener("touchend", m);
    }), Xe(() => {
      b.value && (b.value.removeEventListener("mousemove", u), b.value.removeEventListener("touchmove", u), b.value.removeEventListener("mouseleave", m), b.value.removeEventListener("touchend", m));
    }), (Y, W) => (C(), j("div", {
      class: "vuecal__body",
      ref_key: "bodyEl",
      ref: b,
      style: _e(f.value)
    }, [
      Oe(Ge, { name: "vuecal-shrink" }, {
        default: J(() => [
          V(d).timeAtCursor && H.value !== null ? (C(), j("div", {
            key: 0,
            class: "vuecal__time-at-cursor",
            style: _e(F.value.style)
          }, [
            ge("label", null, ie(F.value.time), 1)
          ], 4)) : K("", !0)
        ]),
        _: 1
      }),
      (C(!0), j(re, null, ke(V(r).cellDates, (q, t) => (C(), Se(ma, {
        key: t,
        start: q.start,
        end: q.end,
        index: t
      }, je({ _: 2 }, [
        Y.$slots.cell ? {
          name: "cell",
          fn: J((o) => [
            P(Y.$slots, "cell", de({ ref_for: !0 }, o))
          ]),
          key: "0"
        } : void 0,
        Y.$slots["cell-date"] ? {
          name: "cell-date",
          fn: J((o) => [
            P(Y.$slots, "cell-date", de({ ref_for: !0 }, o))
          ]),
          key: "1"
        } : void 0,
        Y.$slots["cell-content"] ? {
          name: "cell-content",
          fn: J((o) => [
            P(Y.$slots, "cell-content", de({ ref_for: !0 }, o))
          ]),
          key: "2"
        } : void 0,
        Y.$slots["cell-events"] ? {
          name: "cell-events",
          fn: J((o) => [
            P(Y.$slots, "cell-events", de({ ref_for: !0 }, o))
          ]),
          key: "3"
        } : Y.$slots.event ? {
          name: "event",
          fn: J((o) => [
            P(Y.$slots, "event", de({ ref_for: !0 }, o))
          ]),
          key: "4"
        } : Y.$slots["event-count"] ? {
          name: "event-count",
          fn: J((o) => [
            P(Y.$slots, "event-count", de({ ref_for: !0 }, o))
          ]),
          key: "5"
        } : void 0
      ]), 1032, ["start", "end", "index"]))), 128))
    ], 4));
  }
}, ga = ["data-locale"], ha = { class: "vuecal__scrollable-wrap" }, ya = {
  key: 1,
  class: "vuecal__week-numbers"
}, Da = { class: "vuecal__week-number" }, pa = { class: "vuecal__body-wrap" }, _a = {
  __name: "index",
  props: Ft,
  emits: [
    "ready",
    "view-change",
    "update:view",
    "update:selectedDate",
    "update:viewDate",
    "update:events",
    "event-delete",
    "event-created",
    "event-dropped",
    "event-drag-start",
    "event-drag-end"
  ],
  setup(y, { expose: s, emit: r }) {
    const d = y, w = r, b = _t("vuecal-el"), H = Ot({ props: d, emit: w, attrs: bt(), vuecalEl: b, uid: kt() }), { config: f, view: F, dateUtils: u, touch: m } = H, Y = M(() => f.time && (F.isDay || F.isDays || F.isWeek)), W = M(() => Array(F.rows).fill().map((e, h) => u.getWeek(u.addDays(F.firstCellDate, 7 * h)))), q = M(() => {
      var e;
      return {
        "vuecal--ready": f.ready,
        [`vuecal--${f.theme}-theme`]: f.theme,
        [`vuecal--${f.size}`]: !0,
        "vuecal--date-picker": f.datePicker,
        "vuecal--dark": f.dark,
        "vuecal--light": !f.dark,
        [`vuecal--${F.id}-view`]: !0,
        "vuecal--view-has-time": Y.value,
        "vuecal--timeless": !f.time,
        "vuecal--dragging-cell": m.isDraggingCell,
        "vuecal--dragging-event": m.isDraggingEvent,
        "vuecal--resizing-event": m.isResizingEvent,
        "vuecal--has-schedules": (e = f.schedules) == null ? void 0 : e.length
      };
    }), t = M(() => ({
      "--vuecal-time-cell-height": f.timeCellHeight && `${f.timeCellHeight}px`
    })), o = M(() => {
      var e, h;
      return {
        "vuecal__scrollable--row": Y.value || f.weekNumbers && F.isMonth,
        // Keep the states inside the Vue transition wrapper for smooth CSS transitions.
        [`vuecal__scrollable--${F.id}-view`]: !0,
        "vuecal__scrollable--has-schedules": (e = f.schedules) == null ? void 0 : e.length,
        "vuecal__scrollable--no-schedules": !((h = f.schedules) != null && h.length)
      };
    });
    return qe(async () => {
      await Ue(), f.ready = !0, w("ready", { config: f, view: F });
    }), $t("vuecal", H), s({ view: H.view }), (e, h) => (C(), j("div", {
      class: ye(["vuecal", q.value]),
      ref: "vuecal-el",
      "data-locale": e.locale,
      style: _e(t.value)
    }, [
      e.$slots.diy ? P(e.$slots, "diy", {
        key: 0,
        vuecal: V(H)
      }) : (C(), j(re, { key: 1 }, [
        Oe(At, null, je({ _: 2 }, [
          e.$slots.header ? {
            name: "header",
            fn: J((c) => [
              P(e.$slots, "header", ee(ae(c)))
            ]),
            key: "0"
          } : void 0,
          !e.$slots.header && e.$slots["previous-button"] ? {
            name: "previous-button",
            fn: J((c) => [
              P(e.$slots, "previous-button", ee(ae(c)))
            ]),
            key: "1"
          } : void 0,
          !e.$slots.header && e.$slots["next-button"] ? {
            name: "next-button",
            fn: J((c) => [
              P(e.$slots, "next-button", ee(ae(c)))
            ]),
            key: "2"
          } : void 0,
          !e.$slots.header && e.$slots["today-button"] ? {
            name: "today-button",
            fn: J((c) => [
              P(e.$slots, "today-button", ee(ae(c)))
            ]),
            key: "3"
          } : void 0,
          !e.$slots.header && e.$slots.title ? {
            name: "title",
            fn: J((c) => [
              P(e.$slots, "title", ee(ae(c)))
            ]),
            key: "4"
          } : void 0,
          !e.$slots.header && e.$slots["title.day"] ? {
            name: "title.day",
            fn: J((c) => [
              P(e.$slots, "title.day", ee(ae(c)))
            ]),
            key: "5"
          } : void 0,
          !e.$slots.header && e.$slots["title.days"] ? {
            name: "title.days",
            fn: J((c) => [
              P(e.$slots, "title.days", ee(ae(c)))
            ]),
            key: "6"
          } : void 0,
          !e.$slots.header && e.$slots["title.week"] ? {
            name: "title.week",
            fn: J((c) => [
              P(e.$slots, "title.week", ee(ae(c)))
            ]),
            key: "7"
          } : void 0,
          !e.$slots.header && e.$slots["title.month"] ? {
            name: "title.month",
            fn: J((c) => [
              P(e.$slots, "title.month", ee(ae(c)))
            ]),
            key: "8"
          } : void 0,
          !e.$slots.header && e.$slots["title.year"] ? {
            name: "title.year",
            fn: J((c) => [
              P(e.$slots, "title.year", ee(ae(c)))
            ]),
            key: "9"
          } : void 0,
          !e.$slots.header && e.$slots["title.years"] ? {
            name: "title.years",
            fn: J((c) => [
              P(e.$slots, "title.years", ee(ae(c)))
            ]),
            key: "10"
          } : void 0,
          !e.$slots.header && e.$slots["schedule-heading"] ? {
            name: "schedule-heading",
            fn: J((c) => [
              P(e.$slots, "schedule-heading", ee(ae(c)))
            ]),
            key: "11"
          } : void 0
        ]), 1024),
        ge("div", ha, [
          Oe(Ge, {
            name: `vuecal-slide-fade--${V(F).transitionDirection}`
          }, {
            default: J(() => [
              (C(), j("div", {
                class: ye(["vuecal__scrollable", o.value]),
                key: V(F).id + V(F).start.getTime()
              }, [
                Y.value ? (C(), Se(Kt, { key: 0 }, je({ _: 2 }, [
                  e.$slots["time-cell"] ? {
                    name: "time-cell",
                    fn: J((c) => [
                      P(e.$slots, "time-cell", ee(ae(c)))
                    ]),
                    key: "0"
                  } : void 0
                ]), 1024)) : K("", !0),
                V(f).weekNumbers && V(F).isMonth ? (C(), j("div", ya, [
                  (C(!0), j(re, null, ke(W.value, (c) => (C(), j("div", Da, [
                    P(e.$slots, "week-number", {}, () => [
                      ge("small", null, ie(c), 1)
                    ])
                  ]))), 256))
                ])) : K("", !0),
                ge("div", pa, [
                  Oe(qt, null, je({ _: 2 }, [
                    e.$slots["weekday-heading"] ? {
                      name: "weekday-heading",
                      fn: J((c) => [
                        P(e.$slots, "weekday-heading", ee(ae(c)))
                      ]),
                      key: "0"
                    } : void 0,
                    e.$slots["schedule-heading"] ? {
                      name: "schedule-heading",
                      fn: J((c) => [
                        P(e.$slots, "schedule-heading", ee(ae(c)))
                      ]),
                      key: "1"
                    } : void 0
                  ]), 1024),
                  Oe(fa, null, je({ _: 2 }, [
                    e.$slots.cell ? {
                      name: "cell",
                      fn: J((c) => [
                        P(e.$slots, "cell", ee(ae(c)))
                      ]),
                      key: "0"
                    } : void 0,
                    !e.$slots.cell && e.$slots["cell-date"] ? {
                      name: "cell-date",
                      fn: J((c) => [
                        P(e.$slots, "cell-date", ee(ae(c)))
                      ]),
                      key: "1"
                    } : void 0,
                    !e.$slots.cell && e.$slots["cell-content"] ? {
                      name: "cell-content",
                      fn: J((c) => [
                        P(e.$slots, "cell-content", ee(ae(c)))
                      ]),
                      key: "2"
                    } : void 0,
                    !e.$slots.cell && e.$slots["cell-events"] ? {
                      name: "cell-events",
                      fn: J((c) => [
                        P(e.$slots, "cell-events", ee(ae(c)))
                      ]),
                      key: "3"
                    } : void 0,
                    !e.$slots.cell && e.$slots.event ? {
                      name: "event",
                      fn: J((c) => [
                        P(e.$slots, "event", ee(ae(c)))
                      ]),
                      key: "4"
                    } : void 0,
                    !e.$slots.cell && e.$slots["event-count"] ? {
                      name: "event-count",
                      fn: J((c) => [
                        P(e.$slots, "event-count", ee(ae(c)))
                      ]),
                      key: "5"
                    } : void 0
                  ]), 1024)
                ])
              ], 2))
            ]),
            _: 3
          }, 8, ["name"])
        ])
      ], 64))
    ], 14, ga));
  }
}, ka = (y) => {
  ze.texts = { ...fe.texts, ...y }, ze.dateUtils.updateTexts(ze.texts);
}, {
  addDatePrototypes: ba,
  removeDatePrototypes: $a,
  updateTexts: Ta,
  addDays: Ma,
  subtractDays: Ya,
  addHours: Ea,
  subtractHours: Sa,
  addMinutes: Ca,
  subtractMinutes: Va,
  getWeek: Oa,
  isToday: ja,
  isSameDate: Fa,
  isInRange: Pa,
  isLeapYear: La,
  getPreviousFirstDayOfWeek: Ha,
  stringToDate: za,
  dateToMinutes: Na,
  countDays: Wa,
  datesInSameTimeStep: Aa,
  isValid: Ia,
  formatDate: Ba,
  formatDateLite: Ra,
  formatTime: Xa,
  formatTimeLite: Ga,
  formatMinutes: Ja
} = ze.dateUtils;
export {
  _a as VueCal,
  ba as addDatePrototypes,
  Ma as addDays,
  Ea as addHours,
  Ca as addMinutes,
  Wa as countDays,
  Na as dateToMinutes,
  Aa as datesInSameTimeStep,
  Ba as formatDate,
  Ra as formatDateLite,
  Ja as formatMinutes,
  Xa as formatTime,
  Ga as formatTimeLite,
  Ha as getPreviousFirstDayOfWeek,
  Oa as getWeek,
  Pa as isInRange,
  La as isLeapYear,
  Fa as isSameDate,
  ja as isToday,
  Ia as isValidDate,
  $a as removeDatePrototypes,
  za as stringToDate,
  Ya as subtractDays,
  Sa as subtractHours,
  Va as subtractMinutes,
  Ta as updateTexts,
  ka as useLocale
};
